import { Percent, ChainId, WNATIVE, ERC20Token, CurrencyAmount } from '@donaswap/sdk';
import { firechainTokens, riniaTokens, firechainZkevmTokens, firechainZkevmGhostriderTokens, USDC, USDT, WBTC_ETH, BUSD, sepoliaTokens, holeskyTokens, bscTokens, bscTestnetTokens, polygonTokens, polygonAmoyTokens, polygonZkEvmTokens, polygonZkEvmTestnetTokens, cronosTokens, cronosTestnetTokens, avalancheTokens, avalancheFujiTokens, fantomOperaTokens, fantomTestnetTokens, celoTokens, celoAlfajoresTokens, optimismTokens, optimismGoerliTokens, arbitrumTokens, arbitrumGoerliTokens, shibariumTokens, shibariumTestnetTokens, pulsechainTokens, pulsechainTestnetTokens, xenTokens, xenDevnetTokens, harmonyTokens, harmonyTestnetTokens, coinExTokens, coinExTestnetTokens, dogechainTokens, dogechainTestnetTokens, engramTestnetTokens, etcTokens, etcTestnetTokens, fusionTokens, fusionTestnetTokens, hecoTokens, hecoTestnetTokens, kccTokens, kccTestnetTokens, klaytnCypressTokens, klaytnBaobabTokens, okxChainTokens, okxChainTestnetTokens, thetaTokens, thetaTestnetTokens, ultronTokens, ultronTestnetTokens, moonbeamTokens, moonriverTokens, moonbaseAlphaTokens, auroraTokens, auroraTestnetTokens, bobaTokens, bobaGoerliTokens, gnosisTokens, gnosisChiadoTokens, metisTokens, metisGoerliTokens, telosTokens, telosTestnetTokens, syscoinTokens, syscoinTanenbaumTokens, iotexTokens, iotexTestnetTokens, shidenTokens, astarTokens, shibunyaTokens, fuseTokens, fuseSparknetTokens, velasTokens, velasTestnetTokens, reiTokens, reiTestnetTokens, kekchainTokens, kekchainTestnetTokens, tomochainTokens, tomochainTestnetTokens, thundercoreTokens, thundercoreTestnetTokens, wanchainTokens, wanchainTestnetTokens, rskTokens, rskTestnetTokens, elastosTokens, elastosTestnetTokens, confluxTokens, confluxTestnetTokens, brisechainTokens, brisechainTestnetTokens, muuchainTokens, muuchainTestnetTokens, cantoTokens, cantoTestnetTokens, oasisEmeraldTokens, oasisTestnetTokens, visionTokens, visionTestnetTokens, stepTokens, stepTestnetTokens, meterTokens, meterTestnetTokens, godwokenTokens, godwokenTestnetTokens, callistoTokens, callistoTestnetTokens, evmosTokens, evmosTestnetTokens, energyWebchainTokens, energyVoltaTokens, baseTokens, baseGoerliTokens, kavaTokens, kavaTestnetTokens, cloverTokens, cloverTestnetTokens, defichainTokens, defichainTestnetTokens, bronosTokens, bronosTestnetTokens, filecoinTokens, filecoinCalibrationTokens, flareTokens, flareTestnetTokens, taraxaTokens, taraxaTestnetTokens, zksyncTokens, zkSyncTestnetTokens, lineaTokens, lineaTestnetTokens, bttchainTokens, bttchainTestnetTokens, bobaAvaxTokens, bobaBnbTokens, cmpTokens, cmpTestnetTokens, coreTokens, coreTestnetTokens, cubechainTokens, cubechainTestnetTokens, darwiniaCrabTokens, darwiniaPangolinTokens, diodePretnetTokens, diodeTestnetTokens, gochainTokens, gochainTestnetTokens, haqqTokens, haqqTestedgeTokens, kardiachainTokens, kardiachainTestnetTokens, metadiumTokens, metadiumTestnetTokens, opBnbTokens, opBnbTestnetTokens, palmTokens, palmTestnetTokens, polisTokens, polisTestnetTokens, shibachainTokens, smartBchTokens, smartBchTestnetTokens, songbirdCanaryTokens, thaichainTokens, ubiqTokens, ubiqTestnetTokens, vechainTokens, vechainTestnetTokens, xinfinTokens, xinfinApothemTokens, scrollTokens, scrollSepoliaTokens, xrplDevnetTokens, zetachainTokens, zetachainAthensTokens, zyxTokens, ethereumTokens, goerliTestnetTokens } from '@donaswap/tokens';

var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var BIG_INT_TEN = 10n;
var BIPS_BASE = 10000n;
var MIN_BNB = BIG_INT_TEN ** 16n;
var BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(50n, BIPS_BASE);
var CHAIN_ID_TO_CHAIN_NAME = {
  [ChainId.FIRECHAIN]: "fire",
  [ChainId.RINIA]: "rinia",
  [ChainId.FIRECHAIN_ZKEVM]: "firechainZkevm",
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: "firechainZkevmGhostrider",
  [ChainId.BSC]: "bsc",
  [ChainId.BSC_TESTNET]: "bscTestnet",
  [ChainId.ETHEREUM]: "ethereum",
  [ChainId.GOERLI]: "goerli",
  [ChainId.SEPOLIA]: "sepolia",
  [ChainId.HOLESKY]: "holesky",
  [ChainId.POLYGON]: "polygon",
  [ChainId.POLYGON_AMOY]: "polygonAmoy",
  [ChainId.POLYGON_ZKEVM]: "polygonZkevm",
  [ChainId.POLYGON_ZKEVM_TESTNET]: "polygonZkevmTestnet",
  [ChainId.CRO]: "cronos",
  [ChainId.CRO_TESTNET]: "cronosTestnet",
  [ChainId.AVALANCHE]: "avalanche",
  [ChainId.AVALANCHE_FUJI]: "avalancheFuji",
  [ChainId.FANTOM_OPERA]: "fantomOpera",
  [ChainId.FANTOM_TESTNET]: "fantomTestnet",
  [ChainId.CELO]: "celo",
  [ChainId.CELO_ALFAJORES]: "celoAlfajores",
  [ChainId.OPTIMISM]: "optimism",
  [ChainId.OPTIMISM_GOERLI]: "optimismGoerli",
  [ChainId.SHIBARIUM]: "shibarium",
  [ChainId.SHIBARIUM_TESTNET]: "shibariumTestnet",
  [ChainId.PULSECHAIN]: "pulsechain",
  [ChainId.PULSECHAIN_TESTNET]: "pulsechainTestnet",
  [ChainId.XEN]: "xen",
  [ChainId.XEN_DEVNET]: "xenDevnet",
  [ChainId.HARMONY]: "harmony",
  [ChainId.HARMONY_TESTNET]: "harmonyTestnet",
  [ChainId.COINEX]: "coinEx",
  [ChainId.COINEX_TESTNET]: "coinExTestnet",
  [ChainId.DOGECHAIN]: "dogechain",
  [ChainId.DOGECHAIN_TESTNET]: "dogechainTestnet",
  [ChainId.ENGRAM_TESTNET]: "engramTestnet",
  [ChainId.ETHEREUM_CLASSIC]: "EthereumClassic",
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: "EthereumClassicTestnet",
  [ChainId.FUSION]: "fusion",
  [ChainId.FUSION_TESTNET]: "fusionTestnet",
  [ChainId.HECO]: "heco",
  [ChainId.HECO_TESTNET]: "hecoTestnet",
  [ChainId.KCC]: "kcc",
  [ChainId.KCC_TESTNET]: "kccTestnet",
  [ChainId.KLAYTN]: "klaytn",
  [ChainId.KLAYTN_BAOBAB]: "klaytnBaobob",
  [ChainId.OKXCHAIN]: "okxChain",
  [ChainId.OKXCHAIN_TESTNET]: "okxChainTestnet",
  [ChainId.THETHA]: "theta",
  [ChainId.THETHA_TESTNET]: "thetaTestnet",
  [ChainId.ULTRON]: "ultron",
  [ChainId.ULTRON_TESTNET]: "ultronTestnet",
  [ChainId.MOONBEAM]: "moonbeam",
  [ChainId.MOONRIVER]: "moonriver",
  [ChainId.MOONBASE_ALPHA]: "moonbaseAlpha",
  [ChainId.AURORA]: "aurora",
  [ChainId.AURORA_TESTNET]: "auroraTestnet",
  [ChainId.BOBA]: "boba",
  [ChainId.BOBA_GOERLI]: "bobaGoerli",
  [ChainId.GNOSIS]: "gnosis",
  [ChainId.GNOSIS_CHIADO]: "gnosisChiado",
  [ChainId.METIS]: "metis",
  [ChainId.METIS_GOERLI]: "metisGoerli",
  [ChainId.TELOS]: "telos",
  [ChainId.TELOS_TESTNET]: "telosTestnet",
  [ChainId.SYSCOIN]: "syscoin",
  [ChainId.SYSCOIN_TANENBAUM]: "syscoinTanenbaum",
  [ChainId.IOTEX]: "iotex",
  [ChainId.IOTEX_TESTNET]: "iotexTestnet",
  [ChainId.SHIDEN]: "shiden",
  [ChainId.ASTAR]: "astar",
  [ChainId.SHIBUNYA]: "shibunya",
  [ChainId.FUSE]: "fuse",
  [ChainId.FUSE_SPARKNET]: "fuseSparknet",
  [ChainId.VELAS]: "velas",
  [ChainId.VELAS_TESTNET]: "velasTestnet",
  [ChainId.REI]: "rei",
  [ChainId.REI_TESTNET]: "reiTestnet",
  [ChainId.KEKCHAIN]: "kekchain",
  [ChainId.KEKCHAIN_TESTNET]: "kekchainTestnet",
  [ChainId.TOMOCHAIN]: "tomochain",
  [ChainId.TOMOCHAIN_TESTNET]: "tomochainTestnet",
  [ChainId.THUNDERCORE]: "thundercore",
  [ChainId.THUNDERCORE_TESTNET]: "thundercoreTestnet",
  [ChainId.WANCHAIN]: "wanchain",
  [ChainId.WANCHAIN_TESTNET]: "wanchainTestnet",
  [ChainId.RSK]: "rsk",
  [ChainId.RSK_TESTNET]: "rskTestnet",
  [ChainId.ELASTOS]: "elastos",
  [ChainId.ELASTOS_TESTNET]: "elastosTestnet",
  [ChainId.CONFLUX]: "conflux",
  [ChainId.CONFLUX_TESTNET]: "confluxTestnet",
  [ChainId.BRISECHAIN]: "brisebriseTestnet",
  [ChainId.BRISECHAIN_TESTNET]: "briseTestnet",
  [ChainId.MUUCHAIN]: "muuchain",
  [ChainId.MUUCHAIN_TESTNET]: "muuchainTestnet",
  [ChainId.CANTO]: "canto",
  [ChainId.CANTO_TESTNET]: "cantoTestnet",
  [ChainId.OASIS_EMERALD]: "oasis",
  [ChainId.OASIS_TESTNET]: "oasisTestnet",
  [ChainId.VISION]: "vision",
  [ChainId.VISION_TESTNET]: "visionTestnet",
  [ChainId.STEP]: "step",
  [ChainId.STEP_TESTNET]: "stepTestnet",
  [ChainId.METER]: "meter",
  [ChainId.METER_TESTNET]: "meterTestnet",
  [ChainId.GODWOKEN]: "godwoken",
  [ChainId.GODWOKEN_TESTNET]: "godwokenTestnet",
  [ChainId.CALLISTO]: "callisto",
  [ChainId.CALLISTO_TESTNET]: "callistoTestnet",
  [ChainId.EVMOS]: "evmos",
  [ChainId.EVMOS_TESTNET]: "evmosTestnet",
  [ChainId.ENERGY_WEB_CHAIN]: "energywebchain",
  [ChainId.ENERGY_VOLTA]: "energyVolta",
  [ChainId.BASE]: "base",
  [ChainId.BASE_GOERLI]: "baseGoerli",
  [ChainId.KAVA]: "kava",
  [ChainId.KAVA_TESTNET]: "kavaTestnet",
  [ChainId.CLOVER]: "clover",
  [ChainId.CLOVER_TESTNET]: "cloverTestnet",
  [ChainId.DEFICHAIN]: "defichain",
  [ChainId.DEFICHAIN_TESTNET]: "defichainTestnet",
  [ChainId.BRONOS]: "bronos",
  [ChainId.BRONOS_TESTNET]: "bronosTestnet",
  [ChainId.FILECOIN]: "filecoin",
  [ChainId.FILECOIN_CALIBRATION]: "filecoinCalibration",
  [ChainId.FLARE]: "flare",
  [ChainId.FLARE_TESTNET]: "flareTestnet",
  [ChainId.TARAXA]: "taraxa",
  [ChainId.TARAXA_TESTNET]: "taraxaTestnet",
  [ChainId.ARBITRUM_ONE]: "arbitrum",
  [ChainId.ARBITRUM_GOERLI]: "arbitrumGoerli",
  [ChainId.ZKSYNC]: "era",
  [ChainId.ZKSYNC_TESTNET]: "eraTestnet",
  [ChainId.LINEA]: "linea",
  [ChainId.LINEA_TESTNET]: "lineaTestnet",
  [ChainId.BTTCHAIN]: "bttchain",
  [ChainId.BTTCHAIN_TESTNET]: "bttchainTestnet",
  [ChainId.BOBA_AVAX]: "bobaAvax",
  [ChainId.BOBA_BNB]: "bobaBnb",
  [ChainId.CMP]: "cmp",
  [ChainId.CMP_TESTNET]: "cmpTestnet",
  [ChainId.CORE]: "core",
  [ChainId.CORE_TESTNET]: "coreTestnet",
  [ChainId.CUBECHAIN]: "cubechain",
  [ChainId.CUBECHAIN_TESTNET]: "cubechain",
  [ChainId.DARWINIA_CRAB]: "darwiniaCrab",
  [ChainId.DARWINIA_PANGOLIN]: "darwiniaPangolin",
  [ChainId.DIODE_PRETNET]: "diode",
  [ChainId.DIODE_TESTNET]: "diodeTestnet",
  [ChainId.GOCHAIN]: "gochain",
  [ChainId.GOCHAIN_TESTNET]: "gochainTestnet",
  [ChainId.HAQQ]: "haqq",
  [ChainId.HAQQ_TESTEDGE2]: "haqqTestnet",
  [ChainId.KARDIACHAIN]: "kardiachain",
  [ChainId.KARDIACHAIN_TESTNET]: "kardiachainTestnet",
  [ChainId.METADIUM]: "metadium",
  [ChainId.METADIUM_TESTNET]: "metadiumTestnet",
  [ChainId.OP_BNB]: "opBnb",
  [ChainId.OP_BNB_TESTNET]: "opBnbTestnet",
  [ChainId.PALM]: "palm",
  [ChainId.PALM_TESTNET]: "palmTestnet",
  [ChainId.POLIS]: "polis",
  [ChainId.POLIS_TESTNET]: "polisTestnet",
  [ChainId.SHIBACHAIN]: "shibachain",
  [ChainId.SMART_BCH]: "smartBch",
  [ChainId.SMART_BCH_TESTNET]: "smartBchTestnet",
  [ChainId.SONGBIRD_CANARY]: "songbird",
  [ChainId.THAICHAIN]: "thaichain",
  [ChainId.UBIQ]: "ubiq",
  [ChainId.UBIQ_TESTNET]: "ubiqTestnet",
  [ChainId.VECHAIN]: "vechain",
  [ChainId.VECHAIN_TESTNET]: "vechainTestnet",
  [ChainId.XINFIN]: "xinfin",
  [ChainId.XINFIN_APOTHEM]: "xinfinApothem",
  [ChainId.SCROLL]: "scroll",
  [ChainId.SCROLL_SEPOLIA]: "scrollSepolia",
  [ChainId.XRPL_DEVNET]: "xrplDevnet",
  [ChainId.ZETACHAIN]: "zetachain",
  [ChainId.ZETACHAIN_ATHENS]: "zetachainAthens",
  [ChainId.ZYX]: "zyx"
};
var BASES_TO_CHECK_TRADES_AGAINST = {
  [ChainId.FIRECHAIN]: [firechainTokens.wfire],
  [ChainId.RINIA]: [riniaTokens.wfire],
  [ChainId.FIRECHAIN_ZKEVM]: [firechainZkevmTokens.weth],
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: [firechainZkevmGhostriderTokens.weth],
  [ChainId.ETHEREUM]: [WNATIVE[ChainId.ETHEREUM], USDC[ChainId.ETHEREUM], USDT[ChainId.ETHEREUM], WBTC_ETH],
  [ChainId.GOERLI]: [WNATIVE[ChainId.GOERLI], USDC[ChainId.GOERLI], BUSD[ChainId.GOERLI]],
  [ChainId.SEPOLIA]: [sepoliaTokens.weth, sepoliaTokens.dona],
  [ChainId.HOLESKY]: [holeskyTokens.weth, holeskyTokens.dona],
  [ChainId.BSC]: [
    bscTokens.wbnb,
    bscTokens.flame,
    bscTokens.busd,
    bscTokens.usdt,
    bscTokens.btcb,
    bscTokens.eth,
    bscTokens.usdc
  ],
  [ChainId.BSC_TESTNET]: [bscTestnetTokens.wbnb, bscTestnetTokens.flame, bscTestnetTokens.busd],
  [ChainId.POLYGON]: [polygonTokens.wmatic],
  [ChainId.POLYGON_AMOY]: [polygonAmoyTokens.wmatic],
  [ChainId.POLYGON_ZKEVM]: [polygonZkEvmTokens.weth, polygonZkEvmTokens.usdt],
  [ChainId.POLYGON_ZKEVM_TESTNET]: [polygonZkEvmTestnetTokens.weth, polygonZkEvmTestnetTokens.usdt],
  [ChainId.CRO]: [cronosTokens.wcro],
  [ChainId.CRO_TESTNET]: [cronosTestnetTokens.wcro],
  [ChainId.AVALANCHE]: [avalancheTokens.wavax],
  [ChainId.AVALANCHE_FUJI]: [avalancheFujiTokens.wavax],
  [ChainId.FANTOM_OPERA]: [fantomOperaTokens.wftm],
  [ChainId.FANTOM_TESTNET]: [fantomTestnetTokens.wftm],
  [ChainId.CELO]: [celoTokens.wcelo],
  [ChainId.CELO_ALFAJORES]: [celoAlfajoresTokens.wcelo],
  [ChainId.OPTIMISM]: [optimismTokens.weth],
  [ChainId.OPTIMISM_GOERLI]: [optimismGoerliTokens.weth],
  [ChainId.ARBITRUM_ONE]: [arbitrumTokens.weth, arbitrumTokens.usdt, arbitrumTokens.usdc],
  [ChainId.ARBITRUM_GOERLI]: [arbitrumGoerliTokens.weth, arbitrumGoerliTokens.usdc],
  [ChainId.SHIBARIUM]: [shibariumTokens.wbone],
  [ChainId.SHIBARIUM_TESTNET]: [shibariumTestnetTokens.wbone],
  [ChainId.PULSECHAIN]: [pulsechainTokens.wpls],
  [ChainId.PULSECHAIN_TESTNET]: [pulsechainTestnetTokens.wpls],
  [ChainId.XEN]: [xenTokens.wxn],
  [ChainId.XEN_DEVNET]: [xenDevnetTokens.wxn],
  [ChainId.HARMONY]: [harmonyTokens.wone],
  [ChainId.HARMONY_TESTNET]: [harmonyTestnetTokens.wone],
  [ChainId.COINEX]: [coinExTokens.wcet],
  [ChainId.COINEX_TESTNET]: [coinExTestnetTokens.wcet],
  [ChainId.DOGECHAIN]: [dogechainTokens.wdoge],
  [ChainId.DOGECHAIN_TESTNET]: [dogechainTestnetTokens.wdoge],
  [ChainId.ENGRAM_TESTNET]: [engramTestnetTokens.wgram],
  [ChainId.ETHEREUM_CLASSIC]: [etcTokens.wetc],
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: [etcTestnetTokens.wetc],
  [ChainId.FUSION]: [fusionTokens.wfsn],
  [ChainId.FUSION_TESTNET]: [fusionTestnetTokens.wfsn],
  [ChainId.HECO]: [hecoTokens.wht],
  [ChainId.HECO_TESTNET]: [hecoTestnetTokens.wht],
  [ChainId.KCC]: [kccTokens.wkcs],
  [ChainId.KCC_TESTNET]: [kccTestnetTokens.wkcs],
  [ChainId.KLAYTN]: [klaytnCypressTokens.wklay],
  [ChainId.KLAYTN_BAOBAB]: [klaytnBaobabTokens.wklay],
  [ChainId.OKXCHAIN]: [okxChainTokens.wokt],
  [ChainId.OKXCHAIN_TESTNET]: [okxChainTestnetTokens.wokt],
  [ChainId.THETHA]: [thetaTokens.wtfuel],
  [ChainId.THETHA_TESTNET]: [thetaTestnetTokens.wtfuel],
  [ChainId.ULTRON]: [ultronTokens.wulx],
  [ChainId.ULTRON_TESTNET]: [ultronTestnetTokens.wulx],
  [ChainId.MOONBEAM]: [moonbeamTokens.wglmr],
  [ChainId.MOONRIVER]: [moonriverTokens.wmovr],
  [ChainId.MOONBASE_ALPHA]: [moonbaseAlphaTokens.wdev],
  [ChainId.AURORA]: [auroraTokens.weth],
  [ChainId.AURORA_TESTNET]: [auroraTestnetTokens.weth],
  [ChainId.BOBA]: [bobaTokens.weth],
  [ChainId.BOBA_GOERLI]: [bobaGoerliTokens.weth],
  [ChainId.GNOSIS]: [gnosisTokens.wxdai],
  [ChainId.GNOSIS_CHIADO]: [gnosisChiadoTokens.wxdai],
  [ChainId.METIS]: [metisTokens.wmetis],
  [ChainId.METIS_GOERLI]: [metisGoerliTokens.wmetis],
  [ChainId.TELOS]: [telosTokens.wtlos],
  [ChainId.TELOS_TESTNET]: [telosTestnetTokens.wtlos],
  [ChainId.SYSCOIN]: [syscoinTokens.wsys],
  [ChainId.SYSCOIN_TANENBAUM]: [syscoinTanenbaumTokens.wsys],
  [ChainId.IOTEX]: [iotexTokens.wiotx],
  [ChainId.IOTEX_TESTNET]: [iotexTestnetTokens.wiotx],
  [ChainId.SHIDEN]: [shidenTokens.wsdn],
  [ChainId.ASTAR]: [astarTokens.wastr],
  [ChainId.SHIBUNYA]: [shibunyaTokens.wsby],
  [ChainId.FUSE]: [fuseTokens.wfuse],
  [ChainId.FUSE_SPARKNET]: [fuseSparknetTokens.wfuse],
  [ChainId.VELAS]: [velasTokens.wvlx],
  [ChainId.VELAS_TESTNET]: [velasTestnetTokens.wvlx],
  [ChainId.REI]: [reiTokens.wrei],
  [ChainId.REI_TESTNET]: [reiTestnetTokens.wrei],
  [ChainId.KEKCHAIN]: [kekchainTokens.wkek],
  [ChainId.KEKCHAIN_TESTNET]: [kekchainTestnetTokens.wkek],
  [ChainId.TOMOCHAIN]: [tomochainTokens.wtomo],
  [ChainId.TOMOCHAIN_TESTNET]: [tomochainTestnetTokens.wtomo],
  [ChainId.THUNDERCORE]: [thundercoreTokens.wtt],
  [ChainId.THUNDERCORE_TESTNET]: [thundercoreTestnetTokens.wtt],
  [ChainId.WANCHAIN]: [wanchainTokens.wwan],
  [ChainId.WANCHAIN_TESTNET]: [wanchainTestnetTokens.wwan],
  [ChainId.RSK]: [rskTokens.wrbtc],
  [ChainId.RSK_TESTNET]: [rskTestnetTokens.wrbtc],
  [ChainId.ELASTOS]: [elastosTokens.wela],
  [ChainId.ELASTOS_TESTNET]: [elastosTestnetTokens.wela],
  [ChainId.CONFLUX]: [confluxTokens.wcfx],
  [ChainId.CONFLUX_TESTNET]: [confluxTestnetTokens.wcfx],
  [ChainId.BRISECHAIN]: [brisechainTokens.wbrise],
  [ChainId.BRISECHAIN_TESTNET]: [brisechainTestnetTokens.wbrise],
  [ChainId.MUUCHAIN]: [muuchainTokens.wmuu],
  [ChainId.MUUCHAIN_TESTNET]: [muuchainTestnetTokens.wmuu],
  [ChainId.CANTO]: [cantoTokens.wcanto],
  [ChainId.CANTO_TESTNET]: [cantoTestnetTokens.wcanto],
  [ChainId.OASIS_EMERALD]: [oasisEmeraldTokens.wrose],
  [ChainId.OASIS_TESTNET]: [oasisTestnetTokens.wrose],
  [ChainId.VISION]: [visionTokens.wvs],
  [ChainId.VISION_TESTNET]: [visionTestnetTokens.wvs],
  [ChainId.STEP]: [stepTokens.wfitfi],
  [ChainId.STEP_TESTNET]: [stepTestnetTokens.wfitfi],
  [ChainId.METER]: [meterTokens.wmtr],
  [ChainId.METER_TESTNET]: [meterTestnetTokens.wmtr],
  [ChainId.GODWOKEN]: [godwokenTokens.wpckb],
  [ChainId.GODWOKEN_TESTNET]: [godwokenTestnetTokens.wpckb],
  [ChainId.CALLISTO]: [callistoTokens.wclo],
  [ChainId.CALLISTO_TESTNET]: [callistoTestnetTokens.wclo],
  [ChainId.EVMOS]: [evmosTokens.wevmos],
  [ChainId.EVMOS_TESTNET]: [evmosTestnetTokens.wevmos],
  [ChainId.ENERGY_WEB_CHAIN]: [energyWebchainTokens.wewt],
  [ChainId.ENERGY_VOLTA]: [energyVoltaTokens.wewt],
  [ChainId.BASE]: [baseTokens.weth],
  [ChainId.BASE_GOERLI]: [baseGoerliTokens.weth],
  [ChainId.KAVA]: [kavaTokens.wkava],
  [ChainId.KAVA_TESTNET]: [kavaTestnetTokens.wkava],
  [ChainId.CLOVER]: [cloverTokens.wclv],
  [ChainId.CLOVER_TESTNET]: [cloverTestnetTokens.wclv],
  [ChainId.DEFICHAIN]: [defichainTokens.wdfi],
  [ChainId.DEFICHAIN_TESTNET]: [defichainTestnetTokens.wdfi],
  [ChainId.BRONOS]: [bronosTokens.wbro],
  [ChainId.BRONOS_TESTNET]: [bronosTestnetTokens.wbro],
  [ChainId.FILECOIN]: [filecoinTokens.wfil],
  [ChainId.FILECOIN_CALIBRATION]: [filecoinCalibrationTokens.wfil],
  [ChainId.FLARE]: [flareTokens.wflr],
  [ChainId.FLARE_TESTNET]: [flareTestnetTokens.wflr],
  [ChainId.TARAXA]: [taraxaTokens.wtara],
  [ChainId.TARAXA_TESTNET]: [taraxaTestnetTokens.wtara],
  [ChainId.ZKSYNC]: [zksyncTokens.usdc, zksyncTokens.weth],
  [ChainId.ZKSYNC_TESTNET]: [zkSyncTestnetTokens.usdc, zkSyncTestnetTokens.weth],
  [ChainId.LINEA]: [lineaTokens.usdc, lineaTokens.weth],
  [ChainId.LINEA_TESTNET]: [lineaTestnetTokens.usdc, lineaTestnetTokens.weth],
  [ChainId.BTTCHAIN]: [bttchainTokens.wbtt],
  [ChainId.BTTCHAIN_TESTNET]: [bttchainTestnetTokens.wbtt],
  [ChainId.BOBA_AVAX]: [bobaAvaxTokens.wboba],
  [ChainId.BOBA_BNB]: [bobaBnbTokens.wboba],
  [ChainId.CMP]: [cmpTokens.wcmp],
  [ChainId.CMP_TESTNET]: [cmpTestnetTokens.wcmp],
  [ChainId.CORE]: [coreTokens.wcore],
  [ChainId.CORE_TESTNET]: [coreTestnetTokens.wcore],
  [ChainId.CUBECHAIN]: [cubechainTokens.wcube],
  [ChainId.CUBECHAIN_TESTNET]: [cubechainTestnetTokens.wcube],
  [ChainId.DARWINIA_CRAB]: [darwiniaCrabTokens.wcrab],
  [ChainId.DARWINIA_PANGOLIN]: [darwiniaPangolinTokens.wpring],
  [ChainId.DIODE_PRETNET]: [diodePretnetTokens.wdiode],
  [ChainId.DIODE_TESTNET]: [diodeTestnetTokens.wdiode],
  [ChainId.GOCHAIN]: [gochainTokens.wgo],
  [ChainId.GOCHAIN_TESTNET]: [gochainTestnetTokens.wgo],
  [ChainId.HAQQ]: [haqqTokens.wislm],
  [ChainId.HAQQ_TESTEDGE2]: [haqqTestedgeTokens.wislm],
  [ChainId.KARDIACHAIN]: [kardiachainTokens.wkai],
  [ChainId.KARDIACHAIN_TESTNET]: [kardiachainTestnetTokens.wkai],
  [ChainId.METADIUM]: [metadiumTokens.wmeta],
  [ChainId.METADIUM_TESTNET]: [metadiumTestnetTokens.wkal],
  [ChainId.OP_BNB]: [opBnbTokens.wbnb],
  [ChainId.OP_BNB_TESTNET]: [opBnbTestnetTokens.wbnb],
  [ChainId.PALM]: [palmTokens.wpalm],
  [ChainId.PALM_TESTNET]: [palmTestnetTokens.wpalm],
  [ChainId.POLIS]: [polisTokens.wpolis],
  [ChainId.POLIS_TESTNET]: [polisTestnetTokens.wpolis],
  [ChainId.SHIBACHAIN]: [shibachainTokens.wshib],
  [ChainId.SMART_BCH]: [smartBchTokens.wbch],
  [ChainId.SMART_BCH_TESTNET]: [smartBchTestnetTokens.wbch],
  [ChainId.SONGBIRD_CANARY]: [songbirdCanaryTokens.wsgb],
  [ChainId.THAICHAIN]: [thaichainTokens.wtch],
  [ChainId.UBIQ]: [ubiqTokens.wubq],
  [ChainId.UBIQ_TESTNET]: [ubiqTestnetTokens.wubq],
  [ChainId.VECHAIN]: [vechainTokens.wvet],
  [ChainId.VECHAIN_TESTNET]: [vechainTestnetTokens.wvet],
  [ChainId.XINFIN]: [xinfinTokens.wxdc],
  [ChainId.XINFIN_APOTHEM]: [xinfinApothemTokens.wxdc],
  [ChainId.SCROLL]: [scrollTokens.weth],
  [ChainId.SCROLL_SEPOLIA]: [scrollSepoliaTokens.weth],
  [ChainId.XRPL_DEVNET]: [xrplDevnetTokens.wxrp],
  [ChainId.ZETACHAIN]: [zetachainTokens.wzeta],
  [ChainId.ZETACHAIN_ATHENS]: [zetachainAthensTokens.wzeta],
  [ChainId.ZYX]: [zyxTokens.wzyx]
};
var ADDITIONAL_BASES = {
  [ChainId.BSC]: {
    // SNFTS-SFUND
    [bscTokens.snfts.address]: [bscTokens.sfund],
    [bscTokens.ankr.address]: [bscTokens.ankrbnb],
    [bscTokens.ankrbnb.address]: [bscTokens.ankrETH, bscTokens.ankr],
    [bscTokens.ankrETH.address]: [bscTokens.ankrbnb],
    // REVV - EDU
    [bscTokens.revv.address]: [bscTokens.edu],
    [bscTokens.edu.address]: [bscTokens.revv],
    // unshETH - USH
    [bscTokens.unshETH.address]: [bscTokens.ush],
    [bscTokens.ush.address]: [bscTokens.unshETH]
  },
  [ChainId.ETHEREUM]: {
    // alETH - ALCX
    [ethereumTokens.alcx.address]: [ethereumTokens.alETH],
    [ethereumTokens.alETH.address]: [ethereumTokens.alcx],
    // rETH - ETH
    [ethereumTokens.weth.address]: [ethereumTokens.rETH]
  }
};
var CUSTOM_BASES = {
  [ChainId.BSC]: {
    [bscTokens.axlusdc.address]: [bscTokens.usdt]
  }
};
var V2_FEE_PATH_PLACEHOLDER = 8388608;
var MSG_SENDER = "0x0000000000000000000000000000000000000001";
var ADDRESS_THIS = "0x0000000000000000000000000000000000000002";
var V3_MIXED_ROUTE_QUOTER_ADDRESS = "0x19C6706cFd72f63CCC5B4403f5F8daEC0B569fEe";
var MIXED_ROUTE_QUOTER_ADDRESSES = {
  [ChainId.FIRECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RINIA]: "0x19C6706cFd72f63CCC5B4403f5F8daEC0B569fEe",
  [ChainId.FIRECHAIN_ZKEVM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ETHEREUM]: "0x2feca2f85eeba729D333Df181125adB7217f81da",
  [ChainId.GOERLI]: "0x3B07eA3556CE5BF50E1FA41bAE2aEa8Dbfe92202",
  [ChainId.SEPOLIA]: "0x3B07eA3556CE5BF50E1FA41bAE2aEa8Dbfe92202",
  [ChainId.HOLESKY]: "0x59F985C629B3bAb0A541cF092dBB62C2B8eEbb38",
  [ChainId.BSC]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.BSC_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.POLYGON]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.POLYGON_AMOY]: "0x19C6706cFd72f63CCC5B4403f5F8daEC0B569fEe",
  [ChainId.POLYGON_ZKEVM]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.POLYGON_ZKEVM_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.CRO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CRO_TESTNET]: "0x2feca2f85eeba729D333Df181125adB7217f81da",
  [ChainId.AVALANCHE]: "0x57a9a4eD3FC6192EACd810317DAa4e9c57449ee9",
  [ChainId.AVALANCHE_FUJI]: "0x9F852e531cCA0f69D76e9205826C18B50E65FB9B",
  [ChainId.FANTOM_OPERA]: "0x57a9a4eD3FC6192EACd810317DAa4e9c57449ee9",
  [ChainId.FANTOM_TESTNET]: "0x57a9a4eD3FC6192EACd810317DAa4e9c57449ee9",
  [ChainId.ARBITRUM_ONE]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.ARBITRUM_GOERLI]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.CELO]: "0x02977E9360F8A981F6f5d55590B626f88770c421",
  [ChainId.CELO_ALFAJORES]: "0x8331626DCe0afb57A39D01E98BECD17c204eB89e",
  [ChainId.OPTIMISM]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.OPTIMISM_GOERLI]: "0x2feca2f85eeba729D333Df181125adB7217f81da",
  [ChainId.SHIBARIUM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIBARIUM_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.PULSECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.PULSECHAIN_TESTNET]: "0x750E8DEe4767D9Cc903Fb2a2985307231688cbAF",
  [ChainId.XEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.XEN_DEVNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.HARMONY]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.HARMONY_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.COINEX]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.COINEX_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.DOGECHAIN]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.DOGECHAIN_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.ENGRAM_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.ETHEREUM_CLASSIC]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FUSION]: "0x764339AF4eEf6cf8624BDd0F5c93506E2B2a3E98",
  [ChainId.FUSION_TESTNET]: "0xA03A0f1E4B3cdF1CeDfd4d0F1C8C2A11829Ca537",
  [ChainId.HECO]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.HECO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KCC]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.KCC_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KLAYTN]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.KLAYTN_BAOBAB]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.OKXCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OKXCHAIN_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.THETHA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.THETHA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ULTRON]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ULTRON_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.MOONBEAM]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.MOONRIVER]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.MOONBASE_ALPHA]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.AURORA]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.AURORA_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.BOBA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BOBA_GOERLI]: "0x19C6706cFd72f63CCC5B4403f5F8daEC0B569fEe",
  [ChainId.GNOSIS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GNOSIS_CHIADO]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.METIS]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.METIS_GOERLI]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.TELOS]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.TELOS_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.SYSCOIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SYSCOIN_TANENBAUM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.IOTEX]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.IOTEX_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIDEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ASTAR]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.SHIBUNYA]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.FUSE]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.FUSE_SPARKNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.VELAS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VELAS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.REI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.REI_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KEKCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KEKCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TOMOCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TOMOCHAIN_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.THUNDERCORE]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.THUNDERCORE_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.WANCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.WANCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RSK]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RSK_TESTNET]: "0x2864574953bd39716c987CCe9473d9749442de45",
  [ChainId.ELASTOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ELASTOS_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.CONFLUX]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.CONFLUX_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.BRISECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRISECHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MUUCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MUUCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CANTO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CANTO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OASIS_EMERALD]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OASIS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VISION]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VISION_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.STEP]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.STEP_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METER_TESTNET]: "0x91C80Ccd03DD573110d6B2A249d99A8Fa3b7668a",
  [ChainId.GODWOKEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GODWOKEN_TESTNET]: "0x19C6706cFd72f63CCC5B4403f5F8daEC0B569fEe",
  [ChainId.CALLISTO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CALLISTO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.EVMOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.EVMOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ENERGY_WEB_CHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ENERGY_VOLTA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BASE]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.BASE_GOERLI]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.KAVA]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.KAVA_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.CLOVER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CLOVER_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DEFICHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DEFICHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRONOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRONOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FILECOIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FILECOIN_CALIBRATION]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FLARE]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.FLARE_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.TARAXA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TARAXA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ZKSYNC]: "0x",
  [ChainId.ZKSYNC_TESTNET]: "0x5d2D9b1B04735DFECF48E6be1A7F391e7071DDc9",
  [ChainId.LINEA]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.LINEA_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.BTTCHAIN]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.BTTCHAIN_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.BOBA_AVAX]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.BOBA_BNB]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.CMP]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.CMP_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.CORE]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.CORE_TESTNET]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.CUBECHAIN]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.CUBECHAIN_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.DARWINIA_CRAB]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.DARWINIA_PANGOLIN]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.DIODE_PRETNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.DIODE_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.GOCHAIN]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.GOCHAIN_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.HAQQ]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.HAQQ_TESTEDGE2]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.KARDIACHAIN]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.KARDIACHAIN_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.METADIUM]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.METADIUM_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.OP_BNB]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.OP_BNB_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.PALM]: V3_MIXED_ROUTE_QUOTER_ADDRESS,
  [ChainId.PALM_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.POLIS]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.POLIS_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.SHIBACHAIN]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.SMART_BCH]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.SMART_BCH_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.SONGBIRD_CANARY]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.THAICHAIN]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.UBIQ]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.UBIQ_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.VECHAIN]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.VECHAIN_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.XINFIN]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.XINFIN_APOTHEM]: "0xC255A4147687d5A40032061a4fFdc6b29BaBe9E9",
  [ChainId.SCROLL]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.SCROLL_SEPOLIA]: "0x35f7863d78206A300fB0B271A62658cd50e70385",
  [ChainId.XRPL_DEVNET]: "0x35f7863d78206A300fB0B271A62658cd50e70385",
  [ChainId.ZETACHAIN]: "0x35f7863d78206A300fB0B271A62658cd50e70385",
  [ChainId.ZETACHAIN_ATHENS]: "0x19C6706cFd72f63CCC5B4403f5F8daEC0B569fEe",
  [ChainId.ZYX]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F"
};

// evm/constants/gasModel/v2.ts
var BASE_SWAP_COST_V2 = 135000n;
var COST_PER_EXTRA_HOP_V2 = 50000n;
var COST_PER_UNINIT_TICK = 0n;
var BASE_SWAP_COST_V3 = (id) => {
  switch (id) {
    case ChainId.FIRECHAIN:
    case ChainId.RINIA:
    case ChainId.FIRECHAIN_ZKEVM:
    case ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER:
    case ChainId.ETHEREUM:
    case ChainId.GOERLI:
    case ChainId.SEPOLIA:
    case ChainId.HOLESKY:
    case ChainId.BSC:
    case ChainId.BSC_TESTNET:
    case ChainId.POLYGON:
    case ChainId.POLYGON_AMOY:
    case ChainId.POLYGON_ZKEVM:
    case ChainId.POLYGON_ZKEVM_TESTNET:
    case ChainId.CRO:
    case ChainId.CRO_TESTNET:
    case ChainId.AVALANCHE:
    case ChainId.AVALANCHE_FUJI:
    case ChainId.FANTOM_OPERA:
    case ChainId.FANTOM_TESTNET:
    case ChainId.CELO:
    case ChainId.CELO_ALFAJORES:
    case ChainId.OPTIMISM:
    case ChainId.OPTIMISM_GOERLI:
    case ChainId.ARBITRUM_ONE:
    case ChainId.ARBITRUM_GOERLI:
    case ChainId.SHIBARIUM:
    case ChainId.SHIBARIUM_TESTNET:
    case ChainId.PULSECHAIN:
    case ChainId.PULSECHAIN_TESTNET:
    case ChainId.XEN:
    case ChainId.XEN_DEVNET:
    case ChainId.HARMONY:
    case ChainId.HARMONY_TESTNET:
    case ChainId.COINEX:
    case ChainId.COINEX_TESTNET:
    case ChainId.DOGECHAIN:
    case ChainId.DOGECHAIN_TESTNET:
    case ChainId.ENGRAM_TESTNET:
    case ChainId.ETHEREUM_CLASSIC:
    case ChainId.ETHEREUM_CLASSIC_TESTNET:
    case ChainId.FUSION:
    case ChainId.FUSION_TESTNET:
    case ChainId.HECO:
    case ChainId.HECO_TESTNET:
    case ChainId.KCC:
    case ChainId.KCC_TESTNET:
    case ChainId.KLAYTN:
    case ChainId.KLAYTN_BAOBAB:
    case ChainId.OKXCHAIN:
    case ChainId.OKXCHAIN_TESTNET:
    case ChainId.THETHA:
    case ChainId.THETHA_TESTNET:
    case ChainId.ULTRON:
    case ChainId.ULTRON_TESTNET:
    case ChainId.MOONBEAM:
    case ChainId.MOONRIVER:
    case ChainId.MOONBASE_ALPHA:
    case ChainId.AURORA:
    case ChainId.AURORA_TESTNET:
    case ChainId.BOBA:
    case ChainId.BOBA_GOERLI:
    case ChainId.GNOSIS:
    case ChainId.GNOSIS_CHIADO:
    case ChainId.METIS:
    case ChainId.METIS_GOERLI:
    case ChainId.TELOS:
    case ChainId.TELOS_TESTNET:
    case ChainId.SYSCOIN:
    case ChainId.SYSCOIN_TANENBAUM:
    case ChainId.IOTEX:
    case ChainId.IOTEX_TESTNET:
    case ChainId.SHIDEN:
    case ChainId.ASTAR:
    case ChainId.SHIBUNYA:
    case ChainId.FUSE:
    case ChainId.FUSE_SPARKNET:
    case ChainId.VELAS:
    case ChainId.VELAS_TESTNET:
    case ChainId.REI:
    case ChainId.REI_TESTNET:
    case ChainId.KEKCHAIN:
    case ChainId.KEKCHAIN_TESTNET:
    case ChainId.TOMOCHAIN:
    case ChainId.TOMOCHAIN_TESTNET:
    case ChainId.THUNDERCORE:
    case ChainId.THUNDERCORE_TESTNET:
    case ChainId.WANCHAIN:
    case ChainId.WANCHAIN_TESTNET:
    case ChainId.RSK:
    case ChainId.RSK_TESTNET:
    case ChainId.ELASTOS:
    case ChainId.ELASTOS_TESTNET:
    case ChainId.CONFLUX:
    case ChainId.CONFLUX_TESTNET:
    case ChainId.BRISECHAIN:
    case ChainId.BRISECHAIN_TESTNET:
    case ChainId.MUUCHAIN:
    case ChainId.MUUCHAIN_TESTNET:
    case ChainId.CANTO:
    case ChainId.CANTO_TESTNET:
    case ChainId.OASIS_EMERALD:
    case ChainId.OASIS_TESTNET:
    case ChainId.VISION:
    case ChainId.VISION_TESTNET:
    case ChainId.STEP:
    case ChainId.STEP_TESTNET:
    case ChainId.METER:
    case ChainId.METER_TESTNET:
    case ChainId.GODWOKEN:
    case ChainId.GODWOKEN_TESTNET:
    case ChainId.CALLISTO:
    case ChainId.CALLISTO_TESTNET:
    case ChainId.EVMOS:
    case ChainId.EVMOS_TESTNET:
    case ChainId.ENERGY_WEB_CHAIN:
    case ChainId.ENERGY_VOLTA:
    case ChainId.BASE:
    case ChainId.BASE_GOERLI:
    case ChainId.KAVA:
    case ChainId.KAVA_TESTNET:
    case ChainId.CLOVER_TESTNET:
    case ChainId.DEFICHAIN:
    case ChainId.DEFICHAIN_TESTNET:
    case ChainId.BRONOS:
    case ChainId.BRONOS_TESTNET:
    case ChainId.FILECOIN:
    case ChainId.FILECOIN_CALIBRATION:
    case ChainId.FLARE:
    case ChainId.FLARE_TESTNET:
    case ChainId.TARAXA:
    case ChainId.TARAXA_TESTNET:
    case ChainId.ZKSYNC:
    case ChainId.ZKSYNC_TESTNET:
    case ChainId.LINEA:
    case ChainId.LINEA_TESTNET:
    case ChainId.BTTCHAIN:
    case ChainId.BTTCHAIN_TESTNET:
    case ChainId.BOBA_AVAX:
    case ChainId.BOBA_BNB:
    case ChainId.CMP:
    case ChainId.CMP_TESTNET:
    case ChainId.CORE:
    case ChainId.CORE_TESTNET:
    case ChainId.CUBECHAIN:
    case ChainId.CUBECHAIN_TESTNET:
    case ChainId.DARWINIA_CRAB:
    case ChainId.DARWINIA_PANGOLIN:
    case ChainId.DIODE_PRETNET:
    case ChainId.DIODE_TESTNET:
    case ChainId.GOCHAIN:
    case ChainId.GOCHAIN_TESTNET:
    case ChainId.HAQQ:
    case ChainId.HAQQ_TESTEDGE2:
    case ChainId.KARDIACHAIN:
    case ChainId.KARDIACHAIN_TESTNET:
    case ChainId.METADIUM:
    case ChainId.METADIUM_TESTNET:
    case ChainId.OP_BNB:
    case ChainId.OP_BNB_TESTNET:
    case ChainId.PALM:
    case ChainId.PALM_TESTNET:
    case ChainId.POLIS:
    case ChainId.POLIS_TESTNET:
    case ChainId.SHIBACHAIN:
    case ChainId.SMART_BCH:
    case ChainId.SMART_BCH_TESTNET:
    case ChainId.SONGBIRD_CANARY:
    case ChainId.THAICHAIN:
    case ChainId.UBIQ:
    case ChainId.UBIQ_TESTNET:
    case ChainId.VECHAIN:
    case ChainId.VECHAIN_TESTNET:
    case ChainId.XINFIN:
    case ChainId.XINFIN_APOTHEM:
    case ChainId.SCROLL:
    case ChainId.SCROLL_SEPOLIA:
    case ChainId.XRPL_DEVNET:
    case ChainId.ZETACHAIN:
    case ChainId.ZETACHAIN_ATHENS:
    case ChainId.ZYX:
      return 2000n;
    default:
      return 0n;
  }
};
var COST_PER_INIT_TICK = (id) => {
  switch (id) {
    case ChainId.FIRECHAIN:
    case ChainId.RINIA:
    case ChainId.FIRECHAIN_ZKEVM:
    case ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER:
    case ChainId.ETHEREUM:
    case ChainId.GOERLI:
    case ChainId.SEPOLIA:
    case ChainId.HOLESKY:
    case ChainId.BSC:
    case ChainId.BSC_TESTNET:
    case ChainId.POLYGON:
    case ChainId.POLYGON_AMOY:
    case ChainId.POLYGON_ZKEVM:
    case ChainId.POLYGON_ZKEVM_TESTNET:
    case ChainId.CRO:
    case ChainId.CRO_TESTNET:
    case ChainId.AVALANCHE:
    case ChainId.AVALANCHE_FUJI:
    case ChainId.FANTOM_OPERA:
    case ChainId.FANTOM_TESTNET:
    case ChainId.CELO:
    case ChainId.CELO_ALFAJORES:
    case ChainId.OPTIMISM:
    case ChainId.OPTIMISM_GOERLI:
    case ChainId.ARBITRUM_ONE:
    case ChainId.ARBITRUM_GOERLI:
    case ChainId.SHIBARIUM:
    case ChainId.SHIBARIUM_TESTNET:
    case ChainId.PULSECHAIN:
    case ChainId.PULSECHAIN_TESTNET:
    case ChainId.XEN:
    case ChainId.XEN_DEVNET:
    case ChainId.HARMONY:
    case ChainId.HARMONY_TESTNET:
    case ChainId.COINEX:
    case ChainId.COINEX_TESTNET:
    case ChainId.DOGECHAIN:
    case ChainId.DOGECHAIN_TESTNET:
    case ChainId.ENGRAM_TESTNET:
    case ChainId.ETHEREUM_CLASSIC:
    case ChainId.ETHEREUM_CLASSIC_TESTNET:
    case ChainId.FUSION:
    case ChainId.FUSION_TESTNET:
    case ChainId.HECO:
    case ChainId.HECO_TESTNET:
    case ChainId.KCC:
    case ChainId.KCC_TESTNET:
    case ChainId.KLAYTN:
    case ChainId.KLAYTN_BAOBAB:
    case ChainId.OKXCHAIN:
    case ChainId.OKXCHAIN_TESTNET:
    case ChainId.THETHA:
    case ChainId.THETHA_TESTNET:
    case ChainId.ULTRON:
    case ChainId.ULTRON_TESTNET:
    case ChainId.MOONBEAM:
    case ChainId.MOONRIVER:
    case ChainId.MOONBASE_ALPHA:
    case ChainId.AURORA:
    case ChainId.AURORA_TESTNET:
    case ChainId.BOBA:
    case ChainId.BOBA_GOERLI:
    case ChainId.GNOSIS:
    case ChainId.GNOSIS_CHIADO:
    case ChainId.METIS:
    case ChainId.METIS_GOERLI:
    case ChainId.TELOS:
    case ChainId.TELOS_TESTNET:
    case ChainId.SYSCOIN:
    case ChainId.SYSCOIN_TANENBAUM:
    case ChainId.IOTEX:
    case ChainId.IOTEX_TESTNET:
    case ChainId.SHIDEN:
    case ChainId.ASTAR:
    case ChainId.SHIBUNYA:
    case ChainId.FUSE:
    case ChainId.FUSE_SPARKNET:
    case ChainId.VELAS:
    case ChainId.VELAS_TESTNET:
    case ChainId.REI:
    case ChainId.REI_TESTNET:
    case ChainId.KEKCHAIN:
    case ChainId.KEKCHAIN_TESTNET:
    case ChainId.TOMOCHAIN:
    case ChainId.TOMOCHAIN_TESTNET:
    case ChainId.THUNDERCORE:
    case ChainId.THUNDERCORE_TESTNET:
    case ChainId.WANCHAIN:
    case ChainId.WANCHAIN_TESTNET:
    case ChainId.RSK:
    case ChainId.RSK_TESTNET:
    case ChainId.ELASTOS:
    case ChainId.ELASTOS_TESTNET:
    case ChainId.CONFLUX:
    case ChainId.CONFLUX_TESTNET:
    case ChainId.BRISECHAIN:
    case ChainId.BRISECHAIN_TESTNET:
    case ChainId.MUUCHAIN:
    case ChainId.MUUCHAIN_TESTNET:
    case ChainId.CANTO:
    case ChainId.CANTO_TESTNET:
    case ChainId.OASIS_EMERALD:
    case ChainId.OASIS_TESTNET:
    case ChainId.VISION:
    case ChainId.VISION_TESTNET:
    case ChainId.STEP:
    case ChainId.STEP_TESTNET:
    case ChainId.METER:
    case ChainId.METER_TESTNET:
    case ChainId.GODWOKEN:
    case ChainId.GODWOKEN_TESTNET:
    case ChainId.CALLISTO:
    case ChainId.CALLISTO_TESTNET:
    case ChainId.EVMOS:
    case ChainId.EVMOS_TESTNET:
    case ChainId.ENERGY_WEB_CHAIN:
    case ChainId.ENERGY_VOLTA:
    case ChainId.BASE:
    case ChainId.BASE_GOERLI:
    case ChainId.KAVA:
    case ChainId.KAVA_TESTNET:
    case ChainId.CLOVER_TESTNET:
    case ChainId.DEFICHAIN:
    case ChainId.DEFICHAIN_TESTNET:
    case ChainId.BRONOS:
    case ChainId.BRONOS_TESTNET:
    case ChainId.FILECOIN:
    case ChainId.FILECOIN_CALIBRATION:
    case ChainId.FLARE:
    case ChainId.FLARE_TESTNET:
    case ChainId.TARAXA:
    case ChainId.TARAXA_TESTNET:
    case ChainId.ZKSYNC:
    case ChainId.ZKSYNC_TESTNET:
    case ChainId.LINEA:
    case ChainId.LINEA_TESTNET:
    case ChainId.BTTCHAIN:
    case ChainId.BTTCHAIN_TESTNET:
    case ChainId.BOBA_AVAX:
    case ChainId.BOBA_BNB:
    case ChainId.CMP:
    case ChainId.CMP_TESTNET:
    case ChainId.CORE:
    case ChainId.CORE_TESTNET:
    case ChainId.CUBECHAIN:
    case ChainId.CUBECHAIN_TESTNET:
    case ChainId.DARWINIA_CRAB:
    case ChainId.DARWINIA_PANGOLIN:
    case ChainId.DIODE_PRETNET:
    case ChainId.DIODE_TESTNET:
    case ChainId.GOCHAIN:
    case ChainId.GOCHAIN_TESTNET:
    case ChainId.HAQQ:
    case ChainId.HAQQ_TESTEDGE2:
    case ChainId.KARDIACHAIN:
    case ChainId.KARDIACHAIN_TESTNET:
    case ChainId.METADIUM:
    case ChainId.METADIUM_TESTNET:
    case ChainId.OP_BNB:
    case ChainId.OP_BNB_TESTNET:
    case ChainId.PALM:
    case ChainId.PALM_TESTNET:
    case ChainId.POLIS:
    case ChainId.POLIS_TESTNET:
    case ChainId.SHIBACHAIN:
    case ChainId.SMART_BCH:
    case ChainId.SMART_BCH_TESTNET:
    case ChainId.SONGBIRD_CANARY:
    case ChainId.THAICHAIN:
    case ChainId.UBIQ:
    case ChainId.UBIQ_TESTNET:
    case ChainId.VECHAIN:
    case ChainId.VECHAIN_TESTNET:
    case ChainId.XINFIN:
    case ChainId.XINFIN_APOTHEM:
    case ChainId.SCROLL:
    case ChainId.SCROLL_SEPOLIA:
    case ChainId.XRPL_DEVNET:
    case ChainId.ZETACHAIN:
    case ChainId.ZETACHAIN_ATHENS:
    case ChainId.ZYX:
      return 31000n;
    default:
      return 0n;
  }
};
var COST_PER_HOP_V3 = (id) => {
  switch (id) {
    case ChainId.FIRECHAIN:
    case ChainId.RINIA:
    case ChainId.FIRECHAIN_ZKEVM:
    case ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER:
    case ChainId.ETHEREUM:
    case ChainId.GOERLI:
    case ChainId.SEPOLIA:
    case ChainId.HOLESKY:
    case ChainId.BSC:
    case ChainId.BSC_TESTNET:
    case ChainId.POLYGON:
    case ChainId.POLYGON_AMOY:
    case ChainId.POLYGON_ZKEVM:
    case ChainId.POLYGON_ZKEVM_TESTNET:
    case ChainId.CRO:
    case ChainId.CRO_TESTNET:
    case ChainId.AVALANCHE:
    case ChainId.AVALANCHE_FUJI:
    case ChainId.FANTOM_OPERA:
    case ChainId.FANTOM_TESTNET:
    case ChainId.CELO:
    case ChainId.CELO_ALFAJORES:
    case ChainId.OPTIMISM:
    case ChainId.OPTIMISM_GOERLI:
    case ChainId.ARBITRUM_ONE:
    case ChainId.ARBITRUM_GOERLI:
    case ChainId.SHIBARIUM:
    case ChainId.SHIBARIUM_TESTNET:
    case ChainId.PULSECHAIN:
    case ChainId.PULSECHAIN_TESTNET:
    case ChainId.XEN:
    case ChainId.XEN_DEVNET:
    case ChainId.HARMONY:
    case ChainId.HARMONY_TESTNET:
    case ChainId.COINEX:
    case ChainId.COINEX_TESTNET:
    case ChainId.DOGECHAIN:
    case ChainId.DOGECHAIN_TESTNET:
    case ChainId.ENGRAM_TESTNET:
    case ChainId.ETHEREUM_CLASSIC:
    case ChainId.ETHEREUM_CLASSIC_TESTNET:
    case ChainId.FUSION:
    case ChainId.FUSION_TESTNET:
    case ChainId.HECO:
    case ChainId.HECO_TESTNET:
    case ChainId.KCC:
    case ChainId.KCC_TESTNET:
    case ChainId.KLAYTN:
    case ChainId.KLAYTN_BAOBAB:
    case ChainId.OKXCHAIN:
    case ChainId.OKXCHAIN_TESTNET:
    case ChainId.THETHA:
    case ChainId.THETHA_TESTNET:
    case ChainId.ULTRON:
    case ChainId.ULTRON_TESTNET:
    case ChainId.MOONBEAM:
    case ChainId.MOONRIVER:
    case ChainId.MOONBASE_ALPHA:
    case ChainId.AURORA:
    case ChainId.AURORA_TESTNET:
    case ChainId.BOBA:
    case ChainId.BOBA_GOERLI:
    case ChainId.GNOSIS:
    case ChainId.GNOSIS_CHIADO:
    case ChainId.METIS:
    case ChainId.METIS_GOERLI:
    case ChainId.TELOS:
    case ChainId.TELOS_TESTNET:
    case ChainId.SYSCOIN:
    case ChainId.SYSCOIN_TANENBAUM:
    case ChainId.IOTEX:
    case ChainId.IOTEX_TESTNET:
    case ChainId.SHIDEN:
    case ChainId.ASTAR:
    case ChainId.SHIBUNYA:
    case ChainId.FUSE:
    case ChainId.FUSE_SPARKNET:
    case ChainId.VELAS:
    case ChainId.VELAS_TESTNET:
    case ChainId.REI:
    case ChainId.REI_TESTNET:
    case ChainId.KEKCHAIN:
    case ChainId.KEKCHAIN_TESTNET:
    case ChainId.TOMOCHAIN:
    case ChainId.TOMOCHAIN_TESTNET:
    case ChainId.THUNDERCORE:
    case ChainId.THUNDERCORE_TESTNET:
    case ChainId.WANCHAIN:
    case ChainId.WANCHAIN_TESTNET:
    case ChainId.RSK:
    case ChainId.RSK_TESTNET:
    case ChainId.ELASTOS:
    case ChainId.ELASTOS_TESTNET:
    case ChainId.CONFLUX:
    case ChainId.CONFLUX_TESTNET:
    case ChainId.BRISECHAIN:
    case ChainId.BRISECHAIN_TESTNET:
    case ChainId.MUUCHAIN:
    case ChainId.MUUCHAIN_TESTNET:
    case ChainId.CANTO:
    case ChainId.CANTO_TESTNET:
    case ChainId.OASIS_EMERALD:
    case ChainId.OASIS_TESTNET:
    case ChainId.VISION:
    case ChainId.VISION_TESTNET:
    case ChainId.STEP:
    case ChainId.STEP_TESTNET:
    case ChainId.METER:
    case ChainId.METER_TESTNET:
    case ChainId.GODWOKEN:
    case ChainId.GODWOKEN_TESTNET:
    case ChainId.CALLISTO:
    case ChainId.CALLISTO_TESTNET:
    case ChainId.EVMOS:
    case ChainId.EVMOS_TESTNET:
    case ChainId.ENERGY_WEB_CHAIN:
    case ChainId.ENERGY_VOLTA:
    case ChainId.BASE:
    case ChainId.BASE_GOERLI:
    case ChainId.KAVA:
    case ChainId.KAVA_TESTNET:
    case ChainId.CLOVER_TESTNET:
    case ChainId.DEFICHAIN:
    case ChainId.DEFICHAIN_TESTNET:
    case ChainId.BRONOS:
    case ChainId.BRONOS_TESTNET:
    case ChainId.FILECOIN:
    case ChainId.FILECOIN_CALIBRATION:
    case ChainId.FLARE:
    case ChainId.FLARE_TESTNET:
    case ChainId.TARAXA:
    case ChainId.TARAXA_TESTNET:
    case ChainId.ZKSYNC:
    case ChainId.ZKSYNC_TESTNET:
    case ChainId.LINEA:
    case ChainId.LINEA_TESTNET:
    case ChainId.BTTCHAIN:
    case ChainId.BTTCHAIN_TESTNET:
    case ChainId.BOBA_AVAX:
    case ChainId.BOBA_BNB:
    case ChainId.CMP:
    case ChainId.CMP_TESTNET:
    case ChainId.CORE:
    case ChainId.CORE_TESTNET:
    case ChainId.CUBECHAIN:
    case ChainId.CUBECHAIN_TESTNET:
    case ChainId.DARWINIA_CRAB:
    case ChainId.DARWINIA_PANGOLIN:
    case ChainId.DIODE_PRETNET:
    case ChainId.DIODE_TESTNET:
    case ChainId.GOCHAIN:
    case ChainId.GOCHAIN_TESTNET:
    case ChainId.HAQQ:
    case ChainId.HAQQ_TESTEDGE2:
    case ChainId.KARDIACHAIN:
    case ChainId.KARDIACHAIN_TESTNET:
    case ChainId.METADIUM:
    case ChainId.METADIUM_TESTNET:
    case ChainId.OP_BNB:
    case ChainId.OP_BNB_TESTNET:
    case ChainId.PALM:
    case ChainId.PALM_TESTNET:
    case ChainId.POLIS:
    case ChainId.POLIS_TESTNET:
    case ChainId.SHIBACHAIN:
    case ChainId.SMART_BCH:
    case ChainId.SMART_BCH_TESTNET:
    case ChainId.SONGBIRD_CANARY:
    case ChainId.THAICHAIN:
    case ChainId.UBIQ:
    case ChainId.UBIQ_TESTNET:
    case ChainId.VECHAIN:
    case ChainId.VECHAIN_TESTNET:
    case ChainId.XINFIN:
    case ChainId.XINFIN_APOTHEM:
    case ChainId.SCROLL:
    case ChainId.SCROLL_SEPOLIA:
    case ChainId.XRPL_DEVNET:
    case ChainId.ZETACHAIN:
    case ChainId.ZETACHAIN_ATHENS:
    case ChainId.ZYX:
      return 80000n;
    default:
      return 0n;
  }
};

// evm/constants/gasModel/stableSwap.ts
var BASE_SWAP_COST_STABLE_SWAP = 180000n;
var COST_PER_EXTRA_HOP_STABLE_SWAP = 70000n;
var usdGasTokensByChain = {
  [ChainId.FIRECHAIN]: [firechainTokens.usdt],
  [ChainId.RINIA]: [riniaTokens.usdt],
  [ChainId.FIRECHAIN_ZKEVM]: [firechainZkevmTokens.usdt],
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: [firechainZkevmGhostriderTokens.usdt],
  [ChainId.ETHEREUM]: [ethereumTokens.usdt],
  [ChainId.GOERLI]: [goerliTestnetTokens.usdc],
  [ChainId.SEPOLIA]: [sepoliaTokens.usdt],
  [ChainId.HOLESKY]: [holeskyTokens.usdt],
  [ChainId.BSC]: [bscTokens.busd],
  [ChainId.BSC_TESTNET]: [bscTestnetTokens.busd],
  [ChainId.POLYGON]: [polygonTokens.usdt],
  [ChainId.POLYGON_AMOY]: [polygonAmoyTokens.usdt],
  [ChainId.POLYGON_ZKEVM]: [polygonZkEvmTokens.usdt],
  [ChainId.POLYGON_ZKEVM_TESTNET]: [polygonZkEvmTestnetTokens.usdt],
  [ChainId.CRO]: [cronosTokens.usdt],
  [ChainId.CRO_TESTNET]: [cronosTestnetTokens.usdt],
  [ChainId.AVALANCHE]: [avalancheTokens.usdt],
  [ChainId.AVALANCHE_FUJI]: [avalancheFujiTokens.usdt],
  [ChainId.FANTOM_OPERA]: [fantomOperaTokens.usdt],
  [ChainId.FANTOM_TESTNET]: [fantomTestnetTokens.usdt],
  [ChainId.CELO]: [celoTokens.usdt],
  [ChainId.CELO_ALFAJORES]: [celoAlfajoresTokens.usdt],
  [ChainId.OPTIMISM]: [optimismTokens.usdt],
  [ChainId.OPTIMISM_GOERLI]: [optimismGoerliTokens.usdt],
  [ChainId.ARBITRUM_ONE]: [arbitrumTokens.usdc],
  [ChainId.ARBITRUM_GOERLI]: [arbitrumGoerliTokens.usdc],
  [ChainId.SHIBARIUM]: [shibariumTokens.usdt],
  [ChainId.SHIBARIUM_TESTNET]: [shibariumTestnetTokens.usdt],
  [ChainId.PULSECHAIN]: [pulsechainTokens.usdt],
  [ChainId.PULSECHAIN_TESTNET]: [pulsechainTestnetTokens.usdt],
  [ChainId.XEN]: [xenTokens.usdt],
  [ChainId.XEN_DEVNET]: [xenDevnetTokens.usdt],
  [ChainId.HARMONY]: [harmonyTokens.usdt],
  [ChainId.HARMONY_TESTNET]: [harmonyTestnetTokens.usdt],
  [ChainId.COINEX]: [coinExTokens.usdt],
  [ChainId.COINEX_TESTNET]: [coinExTestnetTokens.usdt],
  [ChainId.DOGECHAIN]: [dogechainTokens.usdt],
  [ChainId.DOGECHAIN_TESTNET]: [dogechainTestnetTokens.usdt],
  [ChainId.ENGRAM_TESTNET]: [engramTestnetTokens.usdt],
  [ChainId.ETHEREUM_CLASSIC]: [etcTokens.usdt],
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: [etcTestnetTokens.usdt],
  [ChainId.FUSION]: [fusionTokens.usdt],
  [ChainId.FUSION_TESTNET]: [fusionTestnetTokens.usdt],
  [ChainId.HECO]: [hecoTokens.usdt],
  [ChainId.HECO_TESTNET]: [hecoTestnetTokens.usdt],
  [ChainId.KCC]: [kccTokens.usdt],
  [ChainId.KCC_TESTNET]: [kccTestnetTokens.usdt],
  [ChainId.KLAYTN]: [klaytnCypressTokens.usdt],
  [ChainId.KLAYTN_BAOBAB]: [klaytnBaobabTokens.usdt],
  [ChainId.OKXCHAIN]: [okxChainTokens.usdt],
  [ChainId.OKXCHAIN_TESTNET]: [okxChainTestnetTokens.usdt],
  [ChainId.THETHA]: [thetaTokens.usdt],
  [ChainId.THETHA_TESTNET]: [thetaTestnetTokens.usdt],
  [ChainId.ULTRON]: [ultronTokens.usdt],
  [ChainId.ULTRON_TESTNET]: [ultronTestnetTokens.usdt],
  [ChainId.MOONBEAM]: [moonbeamTokens.usdt],
  [ChainId.MOONRIVER]: [moonriverTokens.usdt],
  [ChainId.MOONBASE_ALPHA]: [moonbaseAlphaTokens.usdt],
  [ChainId.AURORA]: [auroraTokens.usdt],
  [ChainId.AURORA_TESTNET]: [auroraTestnetTokens.usdt],
  [ChainId.BOBA]: [bobaTokens.usdt],
  [ChainId.BOBA_GOERLI]: [bobaGoerliTokens.usdt],
  [ChainId.GNOSIS]: [gnosisTokens.usdt],
  [ChainId.GNOSIS_CHIADO]: [gnosisChiadoTokens.usdt],
  [ChainId.METIS]: [metisTokens.usdt],
  [ChainId.METIS_GOERLI]: [metisGoerliTokens.usdt],
  [ChainId.TELOS]: [telosTokens.usdt],
  [ChainId.TELOS_TESTNET]: [telosTestnetTokens.usdt],
  [ChainId.SYSCOIN]: [syscoinTokens.usdt],
  [ChainId.SYSCOIN_TANENBAUM]: [syscoinTanenbaumTokens.usdt],
  [ChainId.IOTEX]: [iotexTokens.usdt],
  [ChainId.IOTEX_TESTNET]: [iotexTestnetTokens.usdt],
  [ChainId.SHIDEN]: [shidenTokens.usdt],
  [ChainId.ASTAR]: [astarTokens.usdt],
  [ChainId.SHIBUNYA]: [shibunyaTokens.usdt],
  [ChainId.FUSE]: [fuseTokens.usdt],
  [ChainId.FUSE_SPARKNET]: [fuseSparknetTokens.usdt],
  [ChainId.VELAS]: [velasTokens.usdt],
  [ChainId.VELAS_TESTNET]: [velasTestnetTokens.usdt],
  [ChainId.REI]: [reiTokens.usdt],
  [ChainId.REI_TESTNET]: [reiTestnetTokens.usdt],
  [ChainId.KEKCHAIN]: [kekchainTokens.usdt],
  [ChainId.KEKCHAIN_TESTNET]: [kekchainTestnetTokens.usdt],
  [ChainId.TOMOCHAIN]: [tomochainTokens.usdt],
  [ChainId.TOMOCHAIN_TESTNET]: [tomochainTestnetTokens.usdt],
  [ChainId.THUNDERCORE]: [thundercoreTokens.usdt],
  [ChainId.THUNDERCORE_TESTNET]: [thundercoreTestnetTokens.usdt],
  [ChainId.WANCHAIN]: [wanchainTokens.usdt],
  [ChainId.WANCHAIN_TESTNET]: [wanchainTestnetTokens.usdt],
  [ChainId.RSK]: [rskTokens.usdt],
  [ChainId.RSK_TESTNET]: [rskTestnetTokens.usdt],
  [ChainId.ELASTOS]: [elastosTokens.usdt],
  [ChainId.ELASTOS_TESTNET]: [elastosTestnetTokens.usdt],
  [ChainId.CONFLUX]: [confluxTokens.usdt],
  [ChainId.CONFLUX_TESTNET]: [confluxTestnetTokens.usdt],
  [ChainId.BRISECHAIN]: [brisechainTokens.usdt],
  [ChainId.BRISECHAIN_TESTNET]: [brisechainTestnetTokens.usdt],
  [ChainId.MUUCHAIN]: [muuchainTokens.usdt],
  [ChainId.MUUCHAIN_TESTNET]: [muuchainTestnetTokens.usdt],
  [ChainId.CANTO]: [cantoTokens.usdt],
  [ChainId.CANTO_TESTNET]: [cantoTestnetTokens.usdt],
  [ChainId.OASIS_EMERALD]: [oasisEmeraldTokens.usdt],
  [ChainId.OASIS_TESTNET]: [oasisTestnetTokens.usdt],
  [ChainId.VISION]: [visionTokens.usdt],
  [ChainId.VISION_TESTNET]: [visionTestnetTokens.usdt],
  [ChainId.STEP]: [stepTokens.usdt],
  [ChainId.STEP_TESTNET]: [stepTestnetTokens.usdt],
  [ChainId.METER]: [meterTokens.usdt],
  [ChainId.METER_TESTNET]: [meterTestnetTokens.usdt],
  [ChainId.GODWOKEN]: [godwokenTokens.usdt],
  [ChainId.GODWOKEN_TESTNET]: [godwokenTestnetTokens.usdt],
  [ChainId.CALLISTO]: [callistoTokens.usdt],
  [ChainId.CALLISTO_TESTNET]: [callistoTestnetTokens.usdt],
  [ChainId.EVMOS]: [evmosTokens.usdt],
  [ChainId.EVMOS_TESTNET]: [evmosTestnetTokens.usdt],
  [ChainId.ENERGY_WEB_CHAIN]: [energyWebchainTokens.usdt],
  [ChainId.ENERGY_VOLTA]: [energyVoltaTokens.usdt],
  [ChainId.BASE]: [baseTokens.usdt],
  [ChainId.BASE_GOERLI]: [baseGoerliTokens.usdt],
  [ChainId.KAVA]: [kavaTokens.usdt],
  [ChainId.KAVA_TESTNET]: [kavaTestnetTokens.usdt],
  [ChainId.CLOVER]: [cloverTokens.usdt],
  [ChainId.CLOVER_TESTNET]: [cloverTestnetTokens.usdt],
  [ChainId.DEFICHAIN]: [defichainTokens.usdt],
  [ChainId.DEFICHAIN_TESTNET]: [defichainTestnetTokens.usdt],
  [ChainId.BRONOS]: [bronosTokens.usdt],
  [ChainId.BRONOS_TESTNET]: [bronosTestnetTokens.usdt],
  [ChainId.FILECOIN]: [filecoinTokens.usdt],
  [ChainId.FILECOIN_CALIBRATION]: [filecoinCalibrationTokens.usdt],
  [ChainId.FLARE]: [flareTokens.usdt],
  [ChainId.FLARE_TESTNET]: [flareTestnetTokens.usdt],
  [ChainId.TARAXA]: [taraxaTokens.usdt],
  [ChainId.TARAXA_TESTNET]: [taraxaTestnetTokens.usdt],
  [ChainId.ZKSYNC]: [zksyncTokens.usdc],
  [ChainId.ZKSYNC_TESTNET]: [zkSyncTestnetTokens.usdc],
  [ChainId.LINEA]: [lineaTokens.usdc],
  [ChainId.LINEA_TESTNET]: [lineaTestnetTokens.usdc],
  [ChainId.BTTCHAIN]: [bttchainTokens.usdt],
  [ChainId.BTTCHAIN_TESTNET]: [bttchainTestnetTokens.usdt],
  [ChainId.BOBA_AVAX]: [bobaAvaxTokens.usdt],
  [ChainId.BOBA_BNB]: [bobaBnbTokens.usdt],
  [ChainId.CMP]: [cmpTokens.usdt],
  [ChainId.CMP_TESTNET]: [cmpTestnetTokens.usdt],
  [ChainId.CORE]: [coreTokens.usdt],
  [ChainId.CORE_TESTNET]: [coreTestnetTokens.usdt],
  [ChainId.CUBECHAIN]: [cubechainTokens.usdt],
  [ChainId.CUBECHAIN_TESTNET]: [cubechainTestnetTokens.usdt],
  [ChainId.DARWINIA_CRAB]: [darwiniaCrabTokens.usdt],
  [ChainId.DARWINIA_PANGOLIN]: [darwiniaPangolinTokens.usdt],
  [ChainId.DIODE_PRETNET]: [diodePretnetTokens.usdt],
  [ChainId.DIODE_TESTNET]: [diodeTestnetTokens.usdt],
  [ChainId.GOCHAIN]: [gochainTokens.usdt],
  [ChainId.GOCHAIN_TESTNET]: [gochainTestnetTokens.usdt],
  [ChainId.HAQQ]: [haqqTokens.usdt],
  [ChainId.HAQQ_TESTEDGE2]: [haqqTestedgeTokens.usdt],
  [ChainId.KARDIACHAIN]: [kardiachainTokens.usdt],
  [ChainId.KARDIACHAIN_TESTNET]: [kardiachainTestnetTokens.usdt],
  [ChainId.METADIUM]: [metadiumTokens.usdt],
  [ChainId.METADIUM_TESTNET]: [metadiumTestnetTokens.usdt],
  [ChainId.OP_BNB]: [opBnbTokens.usdt],
  [ChainId.OP_BNB_TESTNET]: [opBnbTestnetTokens.usdt],
  [ChainId.PALM]: [palmTokens.usdt],
  [ChainId.PALM_TESTNET]: [palmTestnetTokens.usdt],
  [ChainId.POLIS]: [polisTokens.usdt],
  [ChainId.POLIS_TESTNET]: [polisTestnetTokens.usdt],
  [ChainId.SHIBACHAIN]: [shibachainTokens.usdt],
  [ChainId.SMART_BCH]: [smartBchTokens.usdt],
  [ChainId.SMART_BCH_TESTNET]: [smartBchTestnetTokens.usdt],
  [ChainId.SONGBIRD_CANARY]: [songbirdCanaryTokens.usdt],
  [ChainId.THAICHAIN]: [thaichainTokens.usdt],
  [ChainId.UBIQ]: [ubiqTokens.usdt],
  [ChainId.UBIQ_TESTNET]: [ubiqTestnetTokens.usdt],
  [ChainId.VECHAIN]: [vechainTokens.usdt],
  [ChainId.VECHAIN_TESTNET]: [vechainTestnetTokens.usdt],
  [ChainId.XINFIN]: [xinfinTokens.usdt],
  [ChainId.XINFIN_APOTHEM]: [xinfinApothemTokens.usdt],
  [ChainId.SCROLL]: [scrollTokens.usdt],
  [ChainId.SCROLL_SEPOLIA]: [scrollSepoliaTokens.usdt],
  [ChainId.XRPL_DEVNET]: [xrplDevnetTokens.usdt],
  [ChainId.ZETACHAIN]: [zetachainTokens.usdt],
  [ChainId.ZETACHAIN_ATHENS]: [zetachainAthensTokens.usdt],
  [ChainId.ZYX]: [zyxTokens.usdt]
};
var DEFAULT = {
  defaultConfig: {
    multicallChunk: 150,
    gasLimitOverride: 1e6
  },
  gasErrorFailureOverride: {
    gasLimitOverride: 1e6,
    multicallChunk: 30
  },
  successRateFailureOverrides: {
    gasLimitOverride: 1e6,
    multicallChunk: 40
  }
};
var BATCH_MULTICALL_CONFIGS = {
  [ChainId.BSC_TESTNET]: DEFAULT,
  [ChainId.BSC]: {
    defaultConfig: {
      multicallChunk: 50,
      gasLimitOverride: 1e6
    },
    gasErrorFailureOverride: {
      gasLimitOverride: 1e6,
      multicallChunk: 40
    },
    successRateFailureOverrides: {
      gasLimitOverride: 1e6,
      multicallChunk: 45
    }
  },
  [ChainId.ETHEREUM]: DEFAULT,
  [ChainId.GOERLI]: DEFAULT,
  [ChainId.SEPOLIA]: DEFAULT,
  [ChainId.HOLESKY]: DEFAULT,
  [ChainId.ARBITRUM_ONE]: {
    defaultConfig: {
      multicallChunk: 10,
      gasLimitOverride: 12e6
    },
    gasErrorFailureOverride: {
      gasLimitOverride: 3e7,
      multicallChunk: 6
    },
    successRateFailureOverrides: {
      gasLimitOverride: 3e7,
      multicallChunk: 6
    }
  },
  [ChainId.ARBITRUM_GOERLI]: DEFAULT,
  [ChainId.POLYGON_ZKEVM]: {
    defaultConfig: {
      multicallChunk: 3,
      gasLimitOverride: 3e5
    },
    gasErrorFailureOverride: {
      gasLimitOverride: 3e4,
      multicallChunk: 1
    },
    successRateFailureOverrides: {
      gasLimitOverride: 3e4,
      multicallChunk: 1
    }
  },
  [ChainId.POLYGON_ZKEVM_TESTNET]: {
    defaultConfig: {
      multicallChunk: 3,
      gasLimitOverride: 3e5
    },
    gasErrorFailureOverride: {
      gasLimitOverride: 3e4,
      multicallChunk: 1
    },
    successRateFailureOverrides: {
      gasLimitOverride: 3e4,
      multicallChunk: 1
    }
  },
  [ChainId.FIRECHAIN]: DEFAULT,
  [ChainId.RINIA]: DEFAULT,
  [ChainId.FIRECHAIN_ZKEVM]: DEFAULT,
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: DEFAULT,
  [ChainId.POLYGON]: DEFAULT,
  [ChainId.POLYGON_AMOY]: DEFAULT,
  [ChainId.CRO]: DEFAULT,
  [ChainId.CRO_TESTNET]: DEFAULT,
  [ChainId.AVALANCHE]: DEFAULT,
  [ChainId.AVALANCHE_FUJI]: DEFAULT,
  [ChainId.FANTOM_OPERA]: DEFAULT,
  [ChainId.FANTOM_TESTNET]: DEFAULT,
  [ChainId.CELO]: DEFAULT,
  [ChainId.CELO_ALFAJORES]: DEFAULT,
  [ChainId.OPTIMISM]: DEFAULT,
  [ChainId.OPTIMISM_GOERLI]: DEFAULT,
  [ChainId.SHIBARIUM]: DEFAULT,
  [ChainId.SHIBARIUM_TESTNET]: DEFAULT,
  [ChainId.PULSECHAIN]: DEFAULT,
  [ChainId.PULSECHAIN_TESTNET]: DEFAULT,
  [ChainId.XEN]: DEFAULT,
  [ChainId.XEN_DEVNET]: DEFAULT,
  [ChainId.HARMONY]: DEFAULT,
  [ChainId.HARMONY_TESTNET]: DEFAULT,
  [ChainId.COINEX]: DEFAULT,
  [ChainId.COINEX_TESTNET]: DEFAULT,
  [ChainId.DOGECHAIN]: DEFAULT,
  [ChainId.DOGECHAIN_TESTNET]: DEFAULT,
  [ChainId.ENGRAM_TESTNET]: DEFAULT,
  [ChainId.ETHEREUM_CLASSIC]: DEFAULT,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: DEFAULT,
  [ChainId.FUSION]: DEFAULT,
  [ChainId.FUSION_TESTNET]: DEFAULT,
  [ChainId.HECO]: DEFAULT,
  [ChainId.HECO_TESTNET]: DEFAULT,
  [ChainId.KCC]: DEFAULT,
  [ChainId.KCC_TESTNET]: DEFAULT,
  [ChainId.KLAYTN]: DEFAULT,
  [ChainId.KLAYTN_BAOBAB]: DEFAULT,
  [ChainId.OKXCHAIN]: DEFAULT,
  [ChainId.OKXCHAIN_TESTNET]: DEFAULT,
  [ChainId.THETHA]: DEFAULT,
  [ChainId.THETHA_TESTNET]: DEFAULT,
  [ChainId.ULTRON]: DEFAULT,
  [ChainId.ULTRON_TESTNET]: DEFAULT,
  [ChainId.MOONBEAM]: DEFAULT,
  [ChainId.MOONRIVER]: DEFAULT,
  [ChainId.MOONBASE_ALPHA]: DEFAULT,
  [ChainId.AURORA]: DEFAULT,
  [ChainId.AURORA_TESTNET]: DEFAULT,
  [ChainId.BOBA]: DEFAULT,
  [ChainId.BOBA_GOERLI]: DEFAULT,
  [ChainId.GNOSIS]: DEFAULT,
  [ChainId.GNOSIS_CHIADO]: DEFAULT,
  [ChainId.METIS]: DEFAULT,
  [ChainId.METIS_GOERLI]: DEFAULT,
  [ChainId.TELOS]: DEFAULT,
  [ChainId.TELOS_TESTNET]: DEFAULT,
  [ChainId.SYSCOIN]: DEFAULT,
  [ChainId.SYSCOIN_TANENBAUM]: DEFAULT,
  [ChainId.IOTEX]: DEFAULT,
  [ChainId.IOTEX_TESTNET]: DEFAULT,
  [ChainId.SHIDEN]: DEFAULT,
  [ChainId.ASTAR]: DEFAULT,
  [ChainId.SHIBUNYA]: DEFAULT,
  [ChainId.FUSE]: DEFAULT,
  [ChainId.FUSE_SPARKNET]: DEFAULT,
  [ChainId.VELAS]: DEFAULT,
  [ChainId.VELAS_TESTNET]: DEFAULT,
  [ChainId.REI]: DEFAULT,
  [ChainId.REI_TESTNET]: DEFAULT,
  [ChainId.KEKCHAIN]: DEFAULT,
  [ChainId.KEKCHAIN_TESTNET]: DEFAULT,
  [ChainId.TOMOCHAIN]: DEFAULT,
  [ChainId.TOMOCHAIN_TESTNET]: DEFAULT,
  [ChainId.THUNDERCORE]: DEFAULT,
  [ChainId.THUNDERCORE_TESTNET]: DEFAULT,
  [ChainId.WANCHAIN]: DEFAULT,
  [ChainId.WANCHAIN_TESTNET]: DEFAULT,
  [ChainId.RSK]: DEFAULT,
  [ChainId.RSK_TESTNET]: DEFAULT,
  [ChainId.ELASTOS]: DEFAULT,
  [ChainId.ELASTOS_TESTNET]: DEFAULT,
  [ChainId.CONFLUX]: DEFAULT,
  [ChainId.CONFLUX_TESTNET]: DEFAULT,
  [ChainId.BRISECHAIN]: DEFAULT,
  [ChainId.BRISECHAIN_TESTNET]: DEFAULT,
  [ChainId.MUUCHAIN]: DEFAULT,
  [ChainId.MUUCHAIN_TESTNET]: DEFAULT,
  [ChainId.CANTO]: DEFAULT,
  [ChainId.CANTO_TESTNET]: DEFAULT,
  [ChainId.OASIS_EMERALD]: DEFAULT,
  [ChainId.OASIS_TESTNET]: DEFAULT,
  [ChainId.VISION]: DEFAULT,
  [ChainId.VISION_TESTNET]: DEFAULT,
  [ChainId.STEP]: DEFAULT,
  [ChainId.STEP_TESTNET]: DEFAULT,
  [ChainId.METER]: DEFAULT,
  [ChainId.METER_TESTNET]: DEFAULT,
  [ChainId.GODWOKEN]: DEFAULT,
  [ChainId.GODWOKEN_TESTNET]: DEFAULT,
  [ChainId.CALLISTO]: DEFAULT,
  [ChainId.CALLISTO_TESTNET]: DEFAULT,
  [ChainId.EVMOS]: DEFAULT,
  [ChainId.EVMOS_TESTNET]: DEFAULT,
  [ChainId.ENERGY_WEB_CHAIN]: DEFAULT,
  [ChainId.ENERGY_VOLTA]: DEFAULT,
  [ChainId.BASE]: DEFAULT,
  [ChainId.BASE_GOERLI]: DEFAULT,
  [ChainId.KAVA]: DEFAULT,
  [ChainId.KAVA_TESTNET]: DEFAULT,
  [ChainId.CLOVER]: DEFAULT,
  [ChainId.CLOVER_TESTNET]: DEFAULT,
  [ChainId.DEFICHAIN]: DEFAULT,
  [ChainId.DEFICHAIN_TESTNET]: DEFAULT,
  [ChainId.BRONOS]: DEFAULT,
  [ChainId.BRONOS_TESTNET]: DEFAULT,
  [ChainId.FILECOIN]: DEFAULT,
  [ChainId.FILECOIN_CALIBRATION]: DEFAULT,
  [ChainId.FLARE]: DEFAULT,
  [ChainId.FLARE_TESTNET]: DEFAULT,
  [ChainId.TARAXA]: DEFAULT,
  [ChainId.TARAXA_TESTNET]: DEFAULT,
  [ChainId.ZKSYNC]: DEFAULT,
  [ChainId.ZKSYNC_TESTNET]: DEFAULT,
  [ChainId.LINEA]: DEFAULT,
  [ChainId.LINEA_TESTNET]: DEFAULT,
  [ChainId.BTTCHAIN]: DEFAULT,
  [ChainId.BTTCHAIN_TESTNET]: DEFAULT,
  [ChainId.BOBA_AVAX]: DEFAULT,
  [ChainId.BOBA_BNB]: DEFAULT,
  [ChainId.CMP]: DEFAULT,
  [ChainId.CMP_TESTNET]: DEFAULT,
  [ChainId.CORE]: DEFAULT,
  [ChainId.CORE_TESTNET]: DEFAULT,
  [ChainId.CUBECHAIN]: DEFAULT,
  [ChainId.CUBECHAIN_TESTNET]: DEFAULT,
  [ChainId.DARWINIA_CRAB]: DEFAULT,
  [ChainId.DARWINIA_PANGOLIN]: DEFAULT,
  [ChainId.DIODE_PRETNET]: DEFAULT,
  [ChainId.DIODE_TESTNET]: DEFAULT,
  [ChainId.GOCHAIN]: DEFAULT,
  [ChainId.GOCHAIN_TESTNET]: DEFAULT,
  [ChainId.HAQQ]: DEFAULT,
  [ChainId.HAQQ_TESTEDGE2]: DEFAULT,
  [ChainId.KARDIACHAIN]: DEFAULT,
  [ChainId.KARDIACHAIN_TESTNET]: DEFAULT,
  [ChainId.METADIUM]: DEFAULT,
  [ChainId.METADIUM_TESTNET]: DEFAULT,
  [ChainId.OP_BNB]: DEFAULT,
  [ChainId.OP_BNB_TESTNET]: DEFAULT,
  [ChainId.PALM]: DEFAULT,
  [ChainId.PALM_TESTNET]: DEFAULT,
  [ChainId.POLIS]: DEFAULT,
  [ChainId.POLIS_TESTNET]: DEFAULT,
  [ChainId.SHIBACHAIN]: DEFAULT,
  [ChainId.SMART_BCH]: DEFAULT,
  [ChainId.SMART_BCH_TESTNET]: DEFAULT,
  [ChainId.SONGBIRD_CANARY]: DEFAULT,
  [ChainId.THAICHAIN]: DEFAULT,
  [ChainId.UBIQ]: DEFAULT,
  [ChainId.UBIQ_TESTNET]: DEFAULT,
  [ChainId.VECHAIN]: DEFAULT,
  [ChainId.VECHAIN_TESTNET]: DEFAULT,
  [ChainId.XINFIN]: DEFAULT,
  [ChainId.XINFIN_APOTHEM]: DEFAULT,
  [ChainId.SCROLL]: DEFAULT,
  [ChainId.SCROLL_SEPOLIA]: DEFAULT,
  [ChainId.XRPL_DEVNET]: DEFAULT,
  [ChainId.ZETACHAIN]: DEFAULT,
  [ChainId.ZETACHAIN_ATHENS]: DEFAULT,
  [ChainId.ZYX]: DEFAULT
};
var STABLE_SWAP_INFO_ADDRESS = {
  [ChainId.FIRECHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.RINIA]: "0x0000000000000000000000000000000000000000",
  [ChainId.FIRECHAIN_ZKEVM]: "0x0000000000000000000000000000000000000000",
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: "0x0000000000000000000000000000000000000000",
  [ChainId.ETHEREUM]: "0x0000000000000000000000000000000000000000",
  [ChainId.GOERLI]: "0x0000000000000000000000000000000000000000",
  [ChainId.SEPOLIA]: "0x0000000000000000000000000000000000000000",
  [ChainId.HOLESKY]: "0x0000000000000000000000000000000000000000",
  [ChainId.BSC]: "0x0000000000000000000000000000000000000000",
  [ChainId.BSC_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.POLYGON]: "0x0000000000000000000000000000000000000000",
  [ChainId.POLYGON_AMOY]: "0x0000000000000000000000000000000000000000",
  [ChainId.POLYGON_ZKEVM]: "0x0000000000000000000000000000000000000000",
  [ChainId.POLYGON_ZKEVM_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.CRO]: "0x0000000000000000000000000000000000000000",
  [ChainId.CRO_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.AVALANCHE]: "0x0000000000000000000000000000000000000000",
  [ChainId.AVALANCHE_FUJI]: "0x0000000000000000000000000000000000000000",
  [ChainId.FANTOM_OPERA]: "0x0000000000000000000000000000000000000000",
  [ChainId.FANTOM_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.CELO]: "0x0000000000000000000000000000000000000000",
  [ChainId.CELO_ALFAJORES]: "0x0000000000000000000000000000000000000000",
  [ChainId.OPTIMISM]: "0x0000000000000000000000000000000000000000",
  [ChainId.OPTIMISM_GOERLI]: "0x0000000000000000000000000000000000000000",
  [ChainId.ARBITRUM_ONE]: "0x0000000000000000000000000000000000000000",
  [ChainId.ARBITRUM_GOERLI]: "0x0000000000000000000000000000000000000000",
  [ChainId.SHIBARIUM]: "0x0000000000000000000000000000000000000000",
  [ChainId.SHIBARIUM_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.PULSECHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.PULSECHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.XEN]: "0x0000000000000000000000000000000000000000",
  [ChainId.XEN_DEVNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.HARMONY]: "0x0000000000000000000000000000000000000000",
  [ChainId.HARMONY_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.COINEX]: "0x0000000000000000000000000000000000000000",
  [ChainId.COINEX_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.DOGECHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.DOGECHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.ENGRAM_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.ETHEREUM_CLASSIC]: "0x0000000000000000000000000000000000000000",
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.FUSION]: "0x0000000000000000000000000000000000000000",
  [ChainId.FUSION_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.HECO]: "0x0000000000000000000000000000000000000000",
  [ChainId.HECO_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.KCC]: "0x0000000000000000000000000000000000000000",
  [ChainId.KCC_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.KLAYTN]: "0x0000000000000000000000000000000000000000",
  [ChainId.KLAYTN_BAOBAB]: "0x0000000000000000000000000000000000000000",
  [ChainId.OKXCHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.OKXCHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.THETHA]: "0x0000000000000000000000000000000000000000",
  [ChainId.THETHA_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.ULTRON]: "0x0000000000000000000000000000000000000000",
  [ChainId.ULTRON_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.MOONBEAM]: "0x0000000000000000000000000000000000000000",
  [ChainId.MOONRIVER]: "0x0000000000000000000000000000000000000000",
  [ChainId.MOONBASE_ALPHA]: "0x0000000000000000000000000000000000000000",
  [ChainId.AURORA]: "0x0000000000000000000000000000000000000000",
  [ChainId.AURORA_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.BOBA]: "0x0000000000000000000000000000000000000000",
  [ChainId.BOBA_GOERLI]: "0x0000000000000000000000000000000000000000",
  [ChainId.GNOSIS]: "0x0000000000000000000000000000000000000000",
  [ChainId.GNOSIS_CHIADO]: "0x0000000000000000000000000000000000000000",
  [ChainId.METIS]: "0x0000000000000000000000000000000000000000",
  [ChainId.METIS_GOERLI]: "0x0000000000000000000000000000000000000000",
  [ChainId.TELOS]: "0x0000000000000000000000000000000000000000",
  [ChainId.TELOS_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.SYSCOIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.SYSCOIN_TANENBAUM]: "0x0000000000000000000000000000000000000000",
  [ChainId.IOTEX]: "0x0000000000000000000000000000000000000000",
  [ChainId.IOTEX_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.SHIDEN]: "0x0000000000000000000000000000000000000000",
  [ChainId.ASTAR]: "0x0000000000000000000000000000000000000000",
  [ChainId.SHIBUNYA]: "0x0000000000000000000000000000000000000000",
  [ChainId.FUSE]: "0x0000000000000000000000000000000000000000",
  [ChainId.FUSE_SPARKNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.VELAS]: "0x0000000000000000000000000000000000000000",
  [ChainId.VELAS_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.REI]: "0x0000000000000000000000000000000000000000",
  [ChainId.REI_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.KEKCHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.KEKCHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.TOMOCHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.TOMOCHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.THUNDERCORE]: "0x0000000000000000000000000000000000000000",
  [ChainId.THUNDERCORE_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.WANCHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.WANCHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.RSK]: "0x0000000000000000000000000000000000000000",
  [ChainId.RSK_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.ELASTOS]: "0x0000000000000000000000000000000000000000",
  [ChainId.ELASTOS_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.CONFLUX]: "0x0000000000000000000000000000000000000000",
  [ChainId.CONFLUX_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.BRISECHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.BRISECHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.MUUCHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.MUUCHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.CANTO]: "0x0000000000000000000000000000000000000000",
  [ChainId.CANTO_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.OASIS_EMERALD]: "0x0000000000000000000000000000000000000000",
  [ChainId.OASIS_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.VISION]: "0x0000000000000000000000000000000000000000",
  [ChainId.VISION_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.STEP]: "0x0000000000000000000000000000000000000000",
  [ChainId.STEP_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.METER]: "0x0000000000000000000000000000000000000000",
  [ChainId.METER_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.GODWOKEN]: "0x0000000000000000000000000000000000000000",
  [ChainId.GODWOKEN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.CALLISTO]: "0x0000000000000000000000000000000000000000",
  [ChainId.CALLISTO_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.EVMOS]: "0x0000000000000000000000000000000000000000",
  [ChainId.EVMOS_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.ENERGY_WEB_CHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.ENERGY_VOLTA]: "0x0000000000000000000000000000000000000000",
  [ChainId.BASE]: "0x0000000000000000000000000000000000000000",
  [ChainId.BASE_GOERLI]: "0x0000000000000000000000000000000000000000",
  [ChainId.KAVA]: "0x0000000000000000000000000000000000000000",
  [ChainId.KAVA_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.CLOVER]: "0x0000000000000000000000000000000000000000",
  [ChainId.CLOVER_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.DEFICHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.DEFICHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.BRONOS]: "0x0000000000000000000000000000000000000000",
  [ChainId.BRONOS_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.FILECOIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.FILECOIN_CALIBRATION]: "0x0000000000000000000000000000000000000000",
  [ChainId.FLARE]: "0x0000000000000000000000000000000000000000",
  [ChainId.FLARE_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.TARAXA]: "0x0000000000000000000000000000000000000000",
  [ChainId.TARAXA_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.ZKSYNC]: "0x0000000000000000000000000000000000000000",
  [ChainId.ZKSYNC_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.LINEA]: "0x0000000000000000000000000000000000000000",
  [ChainId.LINEA_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.BTTCHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.BTTCHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.BOBA_AVAX]: "0x0000000000000000000000000000000000000000",
  [ChainId.BOBA_BNB]: "0x0000000000000000000000000000000000000000",
  [ChainId.CMP]: "0x0000000000000000000000000000000000000000",
  [ChainId.CMP_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.CORE]: "0x0000000000000000000000000000000000000000",
  [ChainId.CORE_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.CUBECHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.CUBECHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.DARWINIA_CRAB]: "0x0000000000000000000000000000000000000000",
  [ChainId.DARWINIA_PANGOLIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.DIODE_PRETNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.DIODE_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.GOCHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.GOCHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.HAQQ]: "0x0000000000000000000000000000000000000000",
  [ChainId.HAQQ_TESTEDGE2]: "0x0000000000000000000000000000000000000000",
  [ChainId.KARDIACHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.KARDIACHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.METADIUM]: "0x0000000000000000000000000000000000000000",
  [ChainId.METADIUM_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.OP_BNB]: "0x0000000000000000000000000000000000000000",
  [ChainId.OP_BNB_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.PALM]: "0x0000000000000000000000000000000000000000",
  [ChainId.PALM_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.POLIS]: "0x0000000000000000000000000000000000000000",
  [ChainId.POLIS_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.SHIBACHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.SMART_BCH]: "0x0000000000000000000000000000000000000000",
  [ChainId.SMART_BCH_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.SONGBIRD_CANARY]: "0x0000000000000000000000000000000000000000",
  [ChainId.THAICHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.UBIQ]: "0x0000000000000000000000000000000000000000",
  [ChainId.UBIQ_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.VECHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.VECHAIN_TESTNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.XINFIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.XINFIN_APOTHEM]: "0x0000000000000000000000000000000000000000",
  [ChainId.SCROLL]: "0x0000000000000000000000000000000000000000",
  [ChainId.SCROLL_SEPOLIA]: "0x0000000000000000000000000000000000000000",
  [ChainId.XRPL_DEVNET]: "0x0000000000000000000000000000000000000000",
  [ChainId.ZETACHAIN]: "0x0000000000000000000000000000000000000000",
  [ChainId.ZETACHAIN_ATHENS]: "0x0000000000000000000000000000000000000000",
  [ChainId.ZYX]: "0x0000000000000000000000000000000000000000"
};
var V3_QUOTER_ADDRESS = "0x2864574953bd39716c987CCe9473d9749442de45";
var V3_QUOTER_ADDRESSES = {
  [ChainId.FIRECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RINIA]: "0x2864574953bd39716c987CCe9473d9749442de45",
  [ChainId.FIRECHAIN_ZKEVM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ETHEREUM]: "0x19C6706cFd72f63CCC5B4403f5F8daEC0B569fEe",
  [ChainId.GOERLI]: "0x2feca2f85eeba729D333Df181125adB7217f81da",
  [ChainId.SEPOLIA]: "0x2feca2f85eeba729D333Df181125adB7217f81da",
  [ChainId.HOLESKY]: "0x63FaBb5fF48Ff6067D23994C3971fF7dCB22e804",
  [ChainId.BSC]: V3_QUOTER_ADDRESS,
  [ChainId.BSC_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.POLYGON]: V3_QUOTER_ADDRESS,
  [ChainId.POLYGON_AMOY]: "0x8d0b9A491077a3cA518482949fbea7765AF2f6f2",
  [ChainId.POLYGON_ZKEVM]: V3_QUOTER_ADDRESS,
  [ChainId.POLYGON_ZKEVM_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.CRO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CRO_TESTNET]: "0x19C6706cFd72f63CCC5B4403f5F8daEC0B569fEe",
  [ChainId.AVALANCHE]: "0xB270B5871FE93a32807162cBa3Add0e2d15cf369",
  [ChainId.AVALANCHE_FUJI]: "0xDD67AF440384522bf95d79eEfDAF487E632Df75B",
  [ChainId.FANTOM_OPERA]: "0xB270B5871FE93a32807162cBa3Add0e2d15cf369",
  [ChainId.FANTOM_TESTNET]: "0xB270B5871FE93a32807162cBa3Add0e2d15cf369",
  [ChainId.CELO]: "0x08b0545208532a5EFB612f9adAe12eE2f4B06c88",
  [ChainId.CELO_ALFAJORES]: "0xd96e0603c85FD6fe19b1Df1DA7d4bF1C82356c5D",
  [ChainId.OPTIMISM]: V3_QUOTER_ADDRESS,
  [ChainId.OPTIMISM_GOERLI]: "0x19C6706cFd72f63CCC5B4403f5F8daEC0B569fEe",
  [ChainId.SHIBARIUM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIBARIUM_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.PULSECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.PULSECHAIN_TESTNET]: "0x396D326987e7fAE228E8FE58A2b19106A85fFB29",
  [ChainId.XEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.XEN_DEVNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.HARMONY]: V3_QUOTER_ADDRESS,
  [ChainId.HARMONY_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.COINEX]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.COINEX_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.DOGECHAIN]: V3_QUOTER_ADDRESS,
  [ChainId.DOGECHAIN_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.ENGRAM_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.ETHEREUM_CLASSIC]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FUSION]: "0x91231a30e48222a0656623B8B27E1860fDc4ab59",
  [ChainId.FUSION_TESTNET]: "0xfc752207C403E6863Cc6595725DCeA9dD9140959",
  [ChainId.HECO]: V3_QUOTER_ADDRESS,
  [ChainId.HECO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KCC]: V3_QUOTER_ADDRESS,
  [ChainId.KCC_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KLAYTN]: V3_QUOTER_ADDRESS,
  [ChainId.KLAYTN_BAOBAB]: V3_QUOTER_ADDRESS,
  [ChainId.OKXCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OKXCHAIN_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.THETHA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.THETHA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ULTRON]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ULTRON_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.MOONBEAM]: V3_QUOTER_ADDRESS,
  [ChainId.MOONRIVER]: V3_QUOTER_ADDRESS,
  [ChainId.MOONBASE_ALPHA]: V3_QUOTER_ADDRESS,
  [ChainId.AURORA]: V3_QUOTER_ADDRESS,
  [ChainId.AURORA_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.BOBA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BOBA_GOERLI]: "0x2864574953bd39716c987CCe9473d9749442de45",
  [ChainId.GNOSIS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GNOSIS_CHIADO]: V3_QUOTER_ADDRESS,
  [ChainId.METIS]: V3_QUOTER_ADDRESS,
  [ChainId.METIS_GOERLI]: V3_QUOTER_ADDRESS,
  [ChainId.TELOS]: V3_QUOTER_ADDRESS,
  [ChainId.TELOS_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.SYSCOIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SYSCOIN_TANENBAUM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.IOTEX]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.IOTEX_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIDEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ASTAR]: V3_QUOTER_ADDRESS,
  [ChainId.SHIBUNYA]: V3_QUOTER_ADDRESS,
  [ChainId.FUSE]: V3_QUOTER_ADDRESS,
  [ChainId.FUSE_SPARKNET]: "0xC255A4147687d5A40032061a4fFdc6b29BaBe9E9",
  [ChainId.VELAS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VELAS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.REI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.REI_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KEKCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KEKCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TOMOCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TOMOCHAIN_TESTNET]: "0xF70B156D803479d42EF42c96005D756F254952f0",
  [ChainId.THUNDERCORE]: V3_QUOTER_ADDRESS,
  [ChainId.THUNDERCORE_TESTNET]: "0x19C6706cFd72f63CCC5B4403f5F8daEC0B569fEe",
  [ChainId.WANCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.WANCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RSK]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RSK_TESTNET]: "0xF70B156D803479d42EF42c96005D756F254952f0",
  [ChainId.ELASTOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ELASTOS_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.CONFLUX]: V3_QUOTER_ADDRESS,
  [ChainId.CONFLUX_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.BRISECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRISECHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MUUCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MUUCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CANTO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CANTO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OASIS_EMERALD]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OASIS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VISION]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VISION_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.STEP]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.STEP_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METER_TESTNET]: "0x30e9077d13D438f64Ba2941686dEb74B9c500A93",
  [ChainId.GODWOKEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GODWOKEN_TESTNET]: "0x2864574953bd39716c987CCe9473d9749442de45",
  [ChainId.CALLISTO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CALLISTO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.EVMOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.EVMOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ENERGY_WEB_CHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ENERGY_VOLTA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BASE]: V3_QUOTER_ADDRESS,
  [ChainId.BASE_GOERLI]: V3_QUOTER_ADDRESS,
  [ChainId.KAVA]: V3_QUOTER_ADDRESS,
  [ChainId.KAVA_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.CLOVER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CLOVER_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DEFICHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DEFICHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRONOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRONOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FILECOIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FILECOIN_CALIBRATION]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FLARE]: V3_QUOTER_ADDRESS,
  [ChainId.FLARE_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.TARAXA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TARAXA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ARBITRUM_ONE]: V3_QUOTER_ADDRESS,
  [ChainId.ARBITRUM_GOERLI]: V3_QUOTER_ADDRESS,
  [ChainId.ZKSYNC]: "0x",
  [ChainId.ZKSYNC_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.LINEA]: V3_QUOTER_ADDRESS,
  [ChainId.LINEA_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.BTTCHAIN]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.BTTCHAIN_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.BOBA_AVAX]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.BOBA_BNB]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.CMP]: V3_QUOTER_ADDRESS,
  [ChainId.CMP_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.CORE]: V3_QUOTER_ADDRESS,
  [ChainId.CORE_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.CUBECHAIN]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.CUBECHAIN_TESTNET]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.DARWINIA_CRAB]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.DARWINIA_PANGOLIN]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.DIODE_PRETNET]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.DIODE_TESTNET]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.GOCHAIN]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.GOCHAIN_TESTNET]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.HAQQ]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.HAQQ_TESTEDGE2]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.KARDIACHAIN]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.KARDIACHAIN_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.METADIUM]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.METADIUM_TESTNET]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.OP_BNB]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.OP_BNB_TESTNET]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.PALM]: V3_QUOTER_ADDRESS,
  [ChainId.PALM_TESTNET]: V3_QUOTER_ADDRESS,
  [ChainId.POLIS]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.POLIS_TESTNET]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.SHIBACHAIN]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.SMART_BCH]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.SMART_BCH_TESTNET]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.SONGBIRD_CANARY]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.THAICHAIN]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.UBIQ]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.UBIQ_TESTNET]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.VECHAIN]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.VECHAIN_TESTNET]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.XINFIN]: "0x669254936caE83bE34008BdFdeeA63C902497B31",
  [ChainId.XINFIN_APOTHEM]: "0x2feca2f85eeba729D333Df181125adB7217f81da",
  [ChainId.SCROLL]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F",
  [ChainId.XRPL_DEVNET]: "0xc8aD8fd20281301d353cea721b9AA4Cfe40147EF",
  [ChainId.ZETACHAIN]: "0xc8aD8fd20281301d353cea721b9AA4Cfe40147EF",
  [ChainId.SCROLL_SEPOLIA]: "0xc8aD8fd20281301d353cea721b9AA4Cfe40147EF",
  [ChainId.ZETACHAIN_ATHENS]: "0x2864574953bd39716c987CCe9473d9749442de45",
  [ChainId.ZYX]: "0x669254936caE83bE34008BdFdeeA63C902497B31"
};
var V3_ROUTER_ADDRESS = "0x2feca2f85eeba729D333Df181125adB7217f81da";
var SMART_ROUTER_ADDRESSES = {
  [ChainId.FIRECHAIN]: "0x13f4EA83D0bd40E75C8222255bc855a974568Dd4",
  [ChainId.RINIA]: "0x2feca2f85eeba729D333Df181125adB7217f81da",
  [ChainId.FIRECHAIN_ZKEVM]: "0x13f4EA83D0bd40E75C8222255bc855a974568Dd4",
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: "0x13f4EA83D0bd40E75C8222255bc855a974568Dd4",
  [ChainId.ETHEREUM]: "0x3B07eA3556CE5BF50E1FA41bAE2aEa8Dbfe92202",
  [ChainId.GOERLI]: "0xC255A4147687d5A40032061a4fFdc6b29BaBe9E9",
  [ChainId.SEPOLIA]: "0xC255A4147687d5A40032061a4fFdc6b29BaBe9E9",
  [ChainId.HOLESKY]: "0x5094C6ABE017095397D96b1576AA054db3CD5F9d",
  [ChainId.BSC]: V3_ROUTER_ADDRESS,
  [ChainId.BSC_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.POLYGON]: V3_ROUTER_ADDRESS,
  [ChainId.POLYGON_AMOY]: "0x2feca2f85eeba729D333Df181125adB7217f81da",
  [ChainId.POLYGON_ZKEVM]: V3_ROUTER_ADDRESS,
  [ChainId.POLYGON_ZKEVM_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.CRO]: "0x9a489505a00cE272eAa5e07Dba6491314CaE3796",
  [ChainId.CRO_TESTNET]: "0xF70B156D803479d42EF42c96005D756F254952f0",
  [ChainId.AVALANCHE]: "0x43Ae351F81Fe918D8cA1EC4672CF0BbAc9Db793e",
  [ChainId.AVALANCHE_FUJI]: "0x3d5A6F3aA8C2420f0d55BF28a43754E7122B9586",
  [ChainId.FANTOM_OPERA]: "0x43Ae351F81Fe918D8cA1EC4672CF0BbAc9Db793e",
  [ChainId.FANTOM_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.CELO]: "0x8Cd5e9e1B2BAA9bBbB312A56e3B69E6be2782c9e",
  [ChainId.CELO_ALFAJORES]: "0x08b0545208532a5EFB612f9adAe12eE2f4B06c88",
  [ChainId.OPTIMISM]: V3_ROUTER_ADDRESS,
  [ChainId.OPTIMISM_GOERLI]: "0x3B07eA3556CE5BF50E1FA41bAE2aEa8Dbfe92202",
  [ChainId.ARBITRUM_ONE]: V3_ROUTER_ADDRESS,
  [ChainId.ARBITRUM_GOERLI]: V3_ROUTER_ADDRESS,
  [ChainId.SHIBARIUM]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.SHIBARIUM_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.PULSECHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.PULSECHAIN_TESTNET]: "0x1dFC067D20B7F8c60980Ca9Ca92aFD2c7A3eb145",
  [ChainId.XEN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.XEN_DEVNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.HARMONY]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.HARMONY_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.COINEX]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.COINEX_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.DOGECHAIN]: V3_ROUTER_ADDRESS,
  [ChainId.DOGECHAIN_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.ENGRAM_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.ETHEREUM_CLASSIC]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FUSION]: "0x3500CD993f1841a70bcCB2762443fdF1EcC8678d",
  [ChainId.FUSION_TESTNET]: "0x43ef19a9a3809Bd14534E18779489D5ce1Da3c02",
  [ChainId.HECO]: V3_ROUTER_ADDRESS,
  [ChainId.HECO_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KCC]: V3_ROUTER_ADDRESS,
  [ChainId.KCC_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KLAYTN]: V3_ROUTER_ADDRESS,
  [ChainId.KLAYTN_BAOBAB]: V3_ROUTER_ADDRESS,
  [ChainId.OKXCHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.OKXCHAIN_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.THETHA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.THETHA_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ULTRON]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ULTRON_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.MOONBEAM]: V3_ROUTER_ADDRESS,
  [ChainId.MOONRIVER]: V3_ROUTER_ADDRESS,
  [ChainId.MOONBASE_ALPHA]: V3_ROUTER_ADDRESS,
  [ChainId.AURORA]: V3_ROUTER_ADDRESS,
  [ChainId.AURORA_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.BOBA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BOBA_GOERLI]: "0x2feca2f85eeba729D333Df181125adB7217f81da",
  [ChainId.GNOSIS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.GNOSIS_CHIADO]: V3_ROUTER_ADDRESS,
  [ChainId.METIS]: V3_ROUTER_ADDRESS,
  [ChainId.METIS_GOERLI]: V3_ROUTER_ADDRESS,
  [ChainId.TELOS]: V3_ROUTER_ADDRESS,
  [ChainId.TELOS_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.SYSCOIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.SYSCOIN_TANENBAUM]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.IOTEX]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.IOTEX_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.SHIDEN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ASTAR]: V3_ROUTER_ADDRESS,
  [ChainId.SHIBUNYA]: V3_ROUTER_ADDRESS,
  [ChainId.FUSE]: V3_ROUTER_ADDRESS,
  [ChainId.FUSE_SPARKNET]: V3_ROUTER_ADDRESS,
  [ChainId.VELAS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.VELAS_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.REI]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.REI_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KEKCHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KEKCHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.TOMOCHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.TOMOCHAIN_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.THUNDERCORE]: V3_ROUTER_ADDRESS,
  [ChainId.THUNDERCORE_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.WANCHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.WANCHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.RSK]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.RSK_TESTNET]: "0x19C6706cFd72f63CCC5B4403f5F8daEC0B569fEe",
  [ChainId.ELASTOS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ELASTOS_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.CONFLUX]: V3_ROUTER_ADDRESS,
  [ChainId.CONFLUX_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.BRISECHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BRISECHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.MUUCHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.MUUCHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CANTO]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CANTO_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.OASIS_EMERALD]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.OASIS_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.VISION]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.VISION_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.STEP]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.STEP_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.METER]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.METER_TESTNET]: "0xa4F904c4fEaD5AfE7945740A237Bd05F1Cf60f7d",
  [ChainId.GODWOKEN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.GODWOKEN_TESTNET]: "0x2feca2f85eeba729D333Df181125adB7217f81da",
  [ChainId.CALLISTO]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CALLISTO_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.EVMOS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.EVMOS_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ENERGY_WEB_CHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ENERGY_VOLTA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BASE]: V3_ROUTER_ADDRESS,
  [ChainId.BASE_GOERLI]: V3_ROUTER_ADDRESS,
  [ChainId.KAVA]: V3_ROUTER_ADDRESS,
  [ChainId.KAVA_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.CLOVER]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CLOVER_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.DEFICHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.DEFICHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BRONOS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BRONOS_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FILECOIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FILECOIN_CALIBRATION]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FLARE]: V3_ROUTER_ADDRESS,
  [ChainId.FLARE_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.TARAXA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.TARAXA_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ZKSYNC]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ZKSYNC_TESTNET]: "0x2CecA0100bB12F3Ee164D260b058281809C7e1E8",
  [ChainId.LINEA]: V3_ROUTER_ADDRESS,
  [ChainId.LINEA_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.BTTCHAIN]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.BTTCHAIN_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.BOBA_AVAX]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.BOBA_BNB]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.CMP]: V3_ROUTER_ADDRESS,
  [ChainId.CMP_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.CORE]: V3_ROUTER_ADDRESS,
  [ChainId.CORE_TESTNET]: V3_ROUTER_ADDRESS,
  [ChainId.CUBECHAIN]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.CUBECHAIN_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.DARWINIA_CRAB]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.DARWINIA_PANGOLIN]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.DIODE_PRETNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.DIODE_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.GOCHAIN]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.GOCHAIN_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.HAQQ]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.HAQQ_TESTEDGE2]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.KARDIACHAIN]: V3_ROUTER_ADDRESS,
  [ChainId.KARDIACHAIN_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.METADIUM]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.METADIUM_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.OP_BNB]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.OP_BNB_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.PALM]: V3_ROUTER_ADDRESS,
  [ChainId.PALM_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.POLIS]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.POLIS_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.SHIBACHAIN]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.SMART_BCH]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.SMART_BCH_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.SONGBIRD_CANARY]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.THAICHAIN]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.UBIQ]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.UBIQ_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.VECHAIN]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.VECHAIN_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.XINFIN]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.XINFIN_APOTHEM]: "0x3B07eA3556CE5BF50E1FA41bAE2aEa8Dbfe92202",
  [ChainId.SCROLL]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87",
  [ChainId.SCROLL_SEPOLIA]: "0x57a9a4eD3FC6192EACd810317DAa4e9c57449ee9",
  [ChainId.XRPL_DEVNET]: "0x57a9a4eD3FC6192EACd810317DAa4e9c57449ee9",
  [ChainId.ZETACHAIN]: "0x57a9a4eD3FC6192EACd810317DAa4e9c57449ee9",
  [ChainId.ZETACHAIN_ATHENS]: "0x2feca2f85eeba729D333Df181125adB7217f81da",
  [ChainId.ZYX]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87"
};
var V2_ROUTER = "0x6E682B51F8bb67294B522b75a1E79dDd4502cc94";
var V2_ROUTER_ADDRESS = {
  [ChainId.FIRECHAIN]: V2_ROUTER,
  [ChainId.RINIA]: V2_ROUTER,
  [ChainId.FIRECHAIN_ZKEVM]: V2_ROUTER,
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: V2_ROUTER,
  [ChainId.ETHEREUM]: V2_ROUTER,
  [ChainId.GOERLI]: V2_ROUTER,
  [ChainId.SEPOLIA]: V2_ROUTER,
  [ChainId.HOLESKY]: V2_ROUTER,
  [ChainId.BSC]: V2_ROUTER,
  [ChainId.BSC_TESTNET]: V2_ROUTER,
  [ChainId.POLYGON]: V2_ROUTER,
  [ChainId.POLYGON_AMOY]: "0xE99D3D35D1a266997809d84C561c733DcBa2aEBb",
  [ChainId.POLYGON_ZKEVM]: V2_ROUTER,
  [ChainId.POLYGON_ZKEVM_TESTNET]: V2_ROUTER,
  [ChainId.CRO]: V2_ROUTER,
  [ChainId.CRO_TESTNET]: V2_ROUTER,
  [ChainId.AVALANCHE]: V2_ROUTER,
  [ChainId.AVALANCHE_FUJI]: V2_ROUTER,
  [ChainId.FANTOM_OPERA]: V2_ROUTER,
  [ChainId.FANTOM_TESTNET]: V2_ROUTER,
  [ChainId.CELO]: V2_ROUTER,
  [ChainId.CELO_ALFAJORES]: V2_ROUTER,
  [ChainId.OPTIMISM]: V2_ROUTER,
  [ChainId.OPTIMISM_GOERLI]: V2_ROUTER,
  [ChainId.SHIBARIUM]: V2_ROUTER,
  [ChainId.SHIBARIUM_TESTNET]: V2_ROUTER,
  [ChainId.PULSECHAIN]: V2_ROUTER,
  [ChainId.PULSECHAIN_TESTNET]: V2_ROUTER,
  [ChainId.XEN]: V2_ROUTER,
  [ChainId.XEN_DEVNET]: V2_ROUTER,
  [ChainId.HARMONY]: V2_ROUTER,
  [ChainId.HARMONY_TESTNET]: V2_ROUTER,
  [ChainId.COINEX]: V2_ROUTER,
  [ChainId.COINEX_TESTNET]: V2_ROUTER,
  [ChainId.DOGECHAIN]: V2_ROUTER,
  [ChainId.DOGECHAIN_TESTNET]: V2_ROUTER,
  [ChainId.ENGRAM_TESTNET]: V2_ROUTER,
  [ChainId.ETHEREUM_CLASSIC]: V2_ROUTER,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: V2_ROUTER,
  [ChainId.FUSION]: V2_ROUTER,
  [ChainId.FUSION_TESTNET]: V2_ROUTER,
  [ChainId.HECO]: V2_ROUTER,
  [ChainId.HECO_TESTNET]: V2_ROUTER,
  [ChainId.KCC]: V2_ROUTER,
  [ChainId.KCC_TESTNET]: V2_ROUTER,
  [ChainId.KLAYTN]: V2_ROUTER,
  [ChainId.KLAYTN_BAOBAB]: V2_ROUTER,
  [ChainId.OKXCHAIN]: V2_ROUTER,
  [ChainId.OKXCHAIN_TESTNET]: V2_ROUTER,
  [ChainId.THETHA]: V2_ROUTER,
  [ChainId.THETHA_TESTNET]: V2_ROUTER,
  [ChainId.ULTRON]: V2_ROUTER,
  [ChainId.ULTRON_TESTNET]: V2_ROUTER,
  [ChainId.MOONBEAM]: V2_ROUTER,
  [ChainId.MOONRIVER]: V2_ROUTER,
  [ChainId.MOONBASE_ALPHA]: V2_ROUTER,
  [ChainId.AURORA]: V2_ROUTER,
  [ChainId.AURORA_TESTNET]: V2_ROUTER,
  [ChainId.BOBA]: V2_ROUTER,
  [ChainId.BOBA_GOERLI]: V2_ROUTER,
  [ChainId.GNOSIS]: V2_ROUTER,
  [ChainId.GNOSIS_CHIADO]: V2_ROUTER,
  [ChainId.METIS]: V2_ROUTER,
  [ChainId.METIS_GOERLI]: V2_ROUTER,
  [ChainId.TELOS]: V2_ROUTER,
  [ChainId.TELOS_TESTNET]: V2_ROUTER,
  [ChainId.SYSCOIN]: V2_ROUTER,
  [ChainId.SYSCOIN_TANENBAUM]: V2_ROUTER,
  [ChainId.IOTEX]: V2_ROUTER,
  [ChainId.IOTEX_TESTNET]: V2_ROUTER,
  [ChainId.SHIDEN]: V2_ROUTER,
  [ChainId.ASTAR]: V2_ROUTER,
  [ChainId.SHIBUNYA]: V2_ROUTER,
  [ChainId.FUSE]: V2_ROUTER,
  [ChainId.FUSE_SPARKNET]: V2_ROUTER,
  [ChainId.VELAS]: V2_ROUTER,
  [ChainId.VELAS_TESTNET]: V2_ROUTER,
  [ChainId.REI]: V2_ROUTER,
  [ChainId.REI_TESTNET]: V2_ROUTER,
  [ChainId.KEKCHAIN]: V2_ROUTER,
  [ChainId.KEKCHAIN_TESTNET]: V2_ROUTER,
  [ChainId.TOMOCHAIN]: V2_ROUTER,
  [ChainId.TOMOCHAIN_TESTNET]: V2_ROUTER,
  [ChainId.THUNDERCORE]: V2_ROUTER,
  [ChainId.THUNDERCORE_TESTNET]: V2_ROUTER,
  [ChainId.WANCHAIN]: V2_ROUTER,
  [ChainId.WANCHAIN_TESTNET]: V2_ROUTER,
  [ChainId.RSK]: V2_ROUTER,
  [ChainId.RSK_TESTNET]: V2_ROUTER,
  [ChainId.ELASTOS]: V2_ROUTER,
  [ChainId.ELASTOS_TESTNET]: V2_ROUTER,
  [ChainId.CONFLUX]: V2_ROUTER,
  [ChainId.CONFLUX_TESTNET]: V2_ROUTER,
  [ChainId.BRISECHAIN]: V2_ROUTER,
  [ChainId.BRISECHAIN_TESTNET]: V2_ROUTER,
  [ChainId.MUUCHAIN]: V2_ROUTER,
  [ChainId.MUUCHAIN_TESTNET]: V2_ROUTER,
  [ChainId.CANTO]: V2_ROUTER,
  [ChainId.CANTO_TESTNET]: V2_ROUTER,
  [ChainId.OASIS_EMERALD]: V2_ROUTER,
  [ChainId.OASIS_TESTNET]: V2_ROUTER,
  [ChainId.VISION]: V2_ROUTER,
  [ChainId.VISION_TESTNET]: V2_ROUTER,
  [ChainId.STEP]: V2_ROUTER,
  [ChainId.STEP_TESTNET]: V2_ROUTER,
  [ChainId.METER]: V2_ROUTER,
  [ChainId.METER_TESTNET]: "",
  [ChainId.GODWOKEN]: V2_ROUTER,
  [ChainId.GODWOKEN_TESTNET]: V2_ROUTER,
  [ChainId.CALLISTO]: V2_ROUTER,
  [ChainId.CALLISTO_TESTNET]: V2_ROUTER,
  [ChainId.EVMOS]: V2_ROUTER,
  [ChainId.EVMOS_TESTNET]: V2_ROUTER,
  [ChainId.ENERGY_WEB_CHAIN]: V2_ROUTER,
  [ChainId.ENERGY_VOLTA]: V2_ROUTER,
  [ChainId.BASE]: V2_ROUTER,
  [ChainId.BASE_GOERLI]: V2_ROUTER,
  [ChainId.KAVA]: V2_ROUTER,
  [ChainId.KAVA_TESTNET]: V2_ROUTER,
  [ChainId.CLOVER]: V2_ROUTER,
  [ChainId.CLOVER_TESTNET]: V2_ROUTER,
  [ChainId.DEFICHAIN]: V2_ROUTER,
  [ChainId.DEFICHAIN_TESTNET]: V2_ROUTER,
  [ChainId.BRONOS]: V2_ROUTER,
  [ChainId.BRONOS_TESTNET]: V2_ROUTER,
  [ChainId.FILECOIN]: V2_ROUTER,
  [ChainId.FILECOIN_CALIBRATION]: V2_ROUTER,
  [ChainId.FLARE]: V2_ROUTER,
  [ChainId.FLARE_TESTNET]: V2_ROUTER,
  [ChainId.TARAXA]: V2_ROUTER,
  [ChainId.TARAXA_TESTNET]: V2_ROUTER,
  [ChainId.ZKSYNC]: V2_ROUTER,
  [ChainId.ZKSYNC_TESTNET]: V2_ROUTER,
  [ChainId.ARBITRUM_ONE]: V2_ROUTER,
  [ChainId.ARBITRUM_GOERLI]: V2_ROUTER,
  [ChainId.LINEA]: V2_ROUTER,
  [ChainId.LINEA_TESTNET]: "0xE99D3D35D1a266997809d84C561c733DcBa2aEBb",
  [ChainId.BTTCHAIN]: V2_ROUTER,
  [ChainId.BTTCHAIN_TESTNET]: V2_ROUTER,
  [ChainId.BOBA_AVAX]: V2_ROUTER,
  [ChainId.BOBA_BNB]: V2_ROUTER,
  [ChainId.CMP]: V2_ROUTER,
  [ChainId.CMP_TESTNET]: V2_ROUTER,
  [ChainId.CORE]: V2_ROUTER,
  [ChainId.CORE_TESTNET]: V2_ROUTER,
  [ChainId.CUBECHAIN]: V2_ROUTER,
  [ChainId.CUBECHAIN_TESTNET]: V2_ROUTER,
  [ChainId.DARWINIA_CRAB]: V2_ROUTER,
  [ChainId.DARWINIA_PANGOLIN]: V2_ROUTER,
  [ChainId.DIODE_PRETNET]: V2_ROUTER,
  [ChainId.DIODE_TESTNET]: V2_ROUTER,
  [ChainId.GOCHAIN]: V2_ROUTER,
  [ChainId.GOCHAIN_TESTNET]: V2_ROUTER,
  [ChainId.HAQQ]: V2_ROUTER,
  [ChainId.HAQQ_TESTEDGE2]: V2_ROUTER,
  [ChainId.KARDIACHAIN]: V2_ROUTER,
  [ChainId.KARDIACHAIN_TESTNET]: V2_ROUTER,
  [ChainId.METADIUM]: V2_ROUTER,
  [ChainId.METADIUM_TESTNET]: V2_ROUTER,
  [ChainId.OP_BNB]: V2_ROUTER,
  [ChainId.OP_BNB_TESTNET]: V2_ROUTER,
  [ChainId.PALM]: V2_ROUTER,
  [ChainId.PALM_TESTNET]: V2_ROUTER,
  [ChainId.POLIS]: V2_ROUTER,
  [ChainId.POLIS_TESTNET]: V2_ROUTER,
  [ChainId.SHIBACHAIN]: V2_ROUTER,
  [ChainId.SMART_BCH]: V2_ROUTER,
  [ChainId.SMART_BCH_TESTNET]: V2_ROUTER,
  [ChainId.SONGBIRD_CANARY]: V2_ROUTER,
  [ChainId.THAICHAIN]: V2_ROUTER,
  [ChainId.UBIQ]: V2_ROUTER,
  [ChainId.UBIQ_TESTNET]: V2_ROUTER,
  [ChainId.VECHAIN]: V2_ROUTER,
  [ChainId.VECHAIN_TESTNET]: V2_ROUTER,
  [ChainId.XINFIN]: V2_ROUTER,
  [ChainId.XINFIN_APOTHEM]: V2_ROUTER,
  [ChainId.SCROLL]: V2_ROUTER,
  [ChainId.SCROLL_SEPOLIA]: "0xE99D3D35D1a266997809d84C561c733DcBa2aEBb",
  [ChainId.XRPL_DEVNET]: V2_ROUTER,
  [ChainId.ZETACHAIN]: V2_ROUTER,
  [ChainId.ZETACHAIN_ATHENS]: "0xC1FEA9B3734207bd6422af49ee38C4c4954F133E",
  [ChainId.ZYX]: V2_ROUTER
};

// evm/constants/stableSwap/529.ts
var pools = [];

// evm/constants/stableSwap/917.ts
var pools2 = [];

// evm/constants/stableSwap/814.ts
var pools3 = [];

// evm/constants/stableSwap/3885.ts
var pools4 = [];

// evm/constants/stableSwap/1.ts
var pools5 = [];

// evm/constants/stableSwap/5.ts
var pools6 = [];

// evm/constants/stableSwap/11155111.ts
var pools7 = [];

// evm/constants/stableSwap/17000.ts
var pools8 = [];
var pools9 = [
  {
    lpSymbol: "HAY-BUSD LP",
    lpAddress: "0xB6040A9F294477dDAdf5543a24E5463B8F2423Ae",
    token: bscTokens.hay,
    quoteToken: bscTokens.busd,
    stableSwapAddress: "0x49079d07ef47449af808a4f36c2a8dec975594ec",
    infoStableSwapAddress: "0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "USDT-BUSD LP",
    lpAddress: "0x36842F8fb99D55477C0Da638aF5ceb6bBf86aA98",
    token: bscTokens.usdt,
    quoteToken: bscTokens.busd,
    stableSwapAddress: "0x169F653A54ACD441aB34B73dA9946e2C451787EF",
    infoStableSwapAddress: "0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6",
    stableLpFee: 5e-5,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "USDC-BUSD LP",
    lpAddress: "0x1A77C359D0019cD8F4d36b7CDf5a88043D801072",
    token: bscTokens.usdc,
    quoteToken: bscTokens.busd,
    stableSwapAddress: "0xc2F5B9a3d9138ab2B74d581fC11346219eBf43Fe",
    infoStableSwapAddress: "0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6",
    stableLpFee: 5e-5,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "USDT-USDC LP",
    lpAddress: "0xee1bcc9F1692E81A281b3a302a4b67890BA4be76",
    token: bscTokens.usdt,
    quoteToken: bscTokens.usdc,
    stableSwapAddress: "0x3EFebC418efB585248A0D2140cfb87aFcc2C63DD",
    infoStableSwapAddress: "0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6",
    stableLpFee: 5e-5,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "axlUSDC-USDT LP",
    lpAddress: "0x1c7e5a3A72b6D94DE5Ec20812E3e68713978a584",
    token: bscTokens.axlusdc,
    quoteToken: bscTokens.usdt,
    stableSwapAddress: "0x6D8fba276ec6F1EDa2344DA48565AdbCA7e4FFa5",
    infoStableSwapAddress: "0x150c8AbEB487137acCC541925408e73b92F39A50",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "WBNB-stkBNB LP",
    lpAddress: "0x9976f5c8BEfDee650226d5571d5F5551e8722b75",
    token: bscTokens.wbnb,
    quoteToken: bscTokens.stkbnb,
    stableSwapAddress: "0x0b03e3d6Ec0c5e5bBf993dED8D947C6fb6eEc18D",
    infoStableSwapAddress: "0x150c8AbEB487137acCC541925408e73b92F39A50",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "BNBx-BNB LP",
    lpAddress: "0x92357Ab9003CA881E08e32CDAE59B10B3161b05C",
    token: bscTokens.bnbx,
    quoteToken: bscTokens.wbnb,
    stableSwapAddress: "0x9c138bE1D76ee4C5162E0fe9D4eEA5542a23D1bD",
    infoStableSwapAddress: "0x150c8AbEB487137acCC541925408e73b92F39A50",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "HAY-USDT LP",
    lpAddress: "0xB2Aa63f363196caba3154D4187949283F085a488",
    token: bscTokens.hay,
    quoteToken: bscTokens.usdt,
    stableSwapAddress: "0xb1Da7D2C257c5700612BdE35C8d7187dc80d79f1",
    infoStableSwapAddress: "0x150c8AbEB487137acCC541925408e73b92F39A50",
    stableLpFee: 4e-4,
    stableLpFeeRateOfTotalFee: 0.5
  }
];
var mockUSDT = new ERC20Token(
  ChainId.BSC_TESTNET,
  "0x0fB5D7c73FA349A90392f873a4FA1eCf6a3d0a96",
  18,
  "USDT",
  "MOCK Token"
);
var pools10 = [
  // {
  //   lpSymbol: 'USDC-BUSD LP',
  //   lpAddress: '0xd1742b5eC6798cEB8C791e0ebbEf606A4946f67E',
  //   token: bscTestnetTokens.usdc, // coins[0]
  //   quoteToken: bscTestnetTokens.busd, // coins[1]
  //   stableSwapAddress: '0x1288026D2c5a76A5bfb0730F615131A448f4Ad06',
  //   infoStableSwapAddress: '0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546',
  // },
  {
    lpSymbol: "USDT-WBNB LP",
    lpAddress: "0x4c091Dc4418Bd3353A87488535528FD86954da2c",
    token: mockUSDT,
    // coins[0]
    quoteToken: bscTestnetTokens.wbnb,
    // coins[1]
    stableSwapAddress: "0xBcd585Ee8B8Ac8de6b0e45dA32Aa31703036b2a1",
    infoStableSwapAddress: "0x0A548d59D04096Bc01206D58C3D63c478e1e06dB",
    stableLpFee: 4e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "USDT-BUSD LP",
    lpAddress: "0x746a7063101E2D3305D1556888ee08193f2B9a07",
    token: mockUSDT,
    // coins[0]
    quoteToken: bscTestnetTokens.busd,
    // coins[1]
    stableSwapAddress: "0xE25A1352477f3DB9B3008B31e9b7a07a18f8A9e6",
    infoStableSwapAddress: "0x0A548d59D04096Bc01206D58C3D63c478e1e06dB",
    stableLpFee: 4e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "BUSD-USDC LP",
    lpAddress: "0x7CA885d338462790DD1B5416ebe6bec75ee045a1",
    token: bscTestnetTokens.mockBusd,
    // coins[0]
    quoteToken: bscTestnetTokens.usdc,
    // coins[1]
    stableSwapAddress: "0xd5E56CD4c8111643a94Ee084df31F44055a1EC9F",
    infoStableSwapAddress: "0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "USDT-BUSD LP",
    lpAddress: "0x9Fa2Ef2C3dF6F903F4b73047311e861C51a11B60",
    token: bscTestnetTokens.usdt,
    // coins[0]
    quoteToken: bscTestnetTokens.mockBusd,
    // coins[1]
    stableSwapAddress: "0xc418d68751Cbe0407C8fdd90Cde73cE95b892f39",
    infoStableSwapAddress: "0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  }
];

// evm/constants/stableSwap/137.ts
var pools11 = [];

// evm/constants/stableSwap/80002.ts
var pools12 = [];

// evm/constants/stableSwap/1101.ts
var pools13 = [];

// evm/constants/stableSwap/1442.ts
var pools14 = [];

// evm/constants/stableSwap/25.ts
var pools15 = [];

// evm/constants/stableSwap/338.ts
var pools16 = [];

// evm/constants/stableSwap/43114.ts
var pools17 = [];

// evm/constants/stableSwap/43113.ts
var pools18 = [];

// evm/constants/stableSwap/250.ts
var pools19 = [];

// evm/constants/stableSwap/4002.ts
var pools20 = [];

// evm/constants/stableSwap/42220.ts
var pools21 = [];

// evm/constants/stableSwap/44787.ts
var pools22 = [];

// evm/constants/stableSwap/10.ts
var pools23 = [];

// evm/constants/stableSwap/420.ts
var pools24 = [];

// evm/constants/stableSwap/42161.ts
var pools25 = [];

// evm/constants/stableSwap/421613.ts
var pools26 = [];

// evm/constants/stableSwap/109.ts
var pools27 = [];

// evm/constants/stableSwap/719.ts
var pools28 = [];

// evm/constants/stableSwap/369.ts
var pools29 = [];

// evm/constants/stableSwap/943.ts
var pools30 = [];

// evm/constants/stableSwap/20221200000.ts
var pools31 = [];

// evm/constants/stableSwap/202212.ts
var pools32 = [];

// evm/constants/stableSwap/1666600000.ts
var pools33 = [];

// evm/constants/stableSwap/1666700000.ts
var pools34 = [];

// evm/constants/stableSwap/52.ts
var pools35 = [];

// evm/constants/stableSwap/53.ts
var pools36 = [];

// evm/constants/stableSwap/2000.ts
var pools37 = [];

// evm/constants/stableSwap/568.ts
var pools38 = [];

// evm/constants/stableSwap/131.ts
var pools39 = [];

// evm/constants/stableSwap/61.ts
var pools40 = [];

// evm/constants/stableSwap/63.ts
var pools41 = [];

// evm/constants/stableSwap/32659.ts
var pools42 = [];

// evm/constants/stableSwap/46688.ts
var pools43 = [];

// evm/constants/stableSwap/128.ts
var pools44 = [];

// evm/constants/stableSwap/256.ts
var pools45 = [];

// evm/constants/stableSwap/321.ts
var pools46 = [];

// evm/constants/stableSwap/322.ts
var pools47 = [];

// evm/constants/stableSwap/8217.ts
var pools48 = [];

// evm/constants/stableSwap/1001.ts
var pools49 = [];

// evm/constants/stableSwap/66.ts
var pools50 = [];

// evm/constants/stableSwap/65.ts
var pools51 = [];

// evm/constants/stableSwap/361.ts
var pools52 = [];

// evm/constants/stableSwap/365.ts
var pools53 = [];

// evm/constants/stableSwap/1231.ts
var pools54 = [];

// evm/constants/stableSwap/1230.ts
var pools55 = [];

// evm/constants/stableSwap/1284.ts
var pools56 = [];

// evm/constants/stableSwap/1285.ts
var pools57 = [];

// evm/constants/stableSwap/1287.ts
var pools58 = [];

// evm/constants/stableSwap/1313161554.ts
var pools59 = [];

// evm/constants/stableSwap/1313161555.ts
var pools60 = [];

// evm/constants/stableSwap/288.ts
var pools61 = [];

// evm/constants/stableSwap/2888.ts
var pools62 = [];

// evm/constants/stableSwap/100.ts
var pools63 = [];

// evm/constants/stableSwap/10200.ts
var pools64 = [];

// evm/constants/stableSwap/1088.ts
var pools65 = [];

// evm/constants/stableSwap/599.ts
var pools66 = [];

// evm/constants/stableSwap/40.ts
var pools67 = [];

// evm/constants/stableSwap/41.ts
var pools68 = [];

// evm/constants/stableSwap/57.ts
var pools69 = [];

// evm/constants/stableSwap/5700.ts
var pools70 = [];

// evm/constants/stableSwap/4689.ts
var pools71 = [];

// evm/constants/stableSwap/4690.ts
var pools72 = [];

// evm/constants/stableSwap/336.ts
var pools73 = [];

// evm/constants/stableSwap/592.ts
var pools74 = [];

// evm/constants/stableSwap/81.ts
var pools75 = [];

// evm/constants/stableSwap/122.ts
var pools76 = [];

// evm/constants/stableSwap/123.ts
var pools77 = [];

// evm/constants/stableSwap/106.ts
var pools78 = [];

// evm/constants/stableSwap/111.ts
var pools79 = [];

// evm/constants/stableSwap/55555.ts
var pools80 = [];

// evm/constants/stableSwap/55556.ts
var pools81 = [];

// evm/constants/stableSwap/420420.ts
var pools82 = [];

// evm/constants/stableSwap/420666.ts
var pools83 = [];

// evm/constants/stableSwap/88.ts
var pools84 = [];

// evm/constants/stableSwap/89.ts
var pools85 = [];

// evm/constants/stableSwap/108.ts
var pools86 = [];

// evm/constants/stableSwap/18.ts
var pools87 = [];

// evm/constants/stableSwap/888.ts
var pools88 = [];

// evm/constants/stableSwap/999.ts
var pools89 = [];

// evm/constants/stableSwap/30.ts
var pools90 = [];

// evm/constants/stableSwap/31.ts
var pools91 = [];

// evm/constants/stableSwap/20.ts
var pools92 = [];

// evm/constants/stableSwap/21.ts
var pools93 = [];

// evm/constants/stableSwap/1030.ts
var pools94 = [];

// evm/constants/stableSwap/71.ts
var pools95 = [];

// evm/constants/stableSwap/32520.ts
var pools96 = [];

// evm/constants/stableSwap/64668.ts
var pools97 = [];

// evm/constants/stableSwap/20402.ts
var pools98 = [];

// evm/constants/stableSwap/42110.ts
var pools99 = [];

// evm/constants/stableSwap/7700.ts
var pools100 = [];

// evm/constants/stableSwap/7701.ts
var pools101 = [];

// evm/constants/stableSwap/42262.ts
var pools102 = [];

// evm/constants/stableSwap/42261.ts
var pools103 = [];

// evm/constants/stableSwap/888888.ts
var pools104 = [];

// evm/constants/stableSwap/666666.ts
var pools105 = [];

// evm/constants/stableSwap/1234.ts
var pools106 = [];

// evm/constants/stableSwap/12345.ts
var pools107 = [];

// evm/constants/stableSwap/82.ts
var pools108 = [];

// evm/constants/stableSwap/83.ts
var pools109 = [];

// evm/constants/stableSwap/71402.ts
var pools110 = [];

// evm/constants/stableSwap/71401.ts
var pools111 = [];

// evm/constants/stableSwap/820.ts
var pools112 = [];

// evm/constants/stableSwap/20729.ts
var pools113 = [];

// evm/constants/stableSwap/9001.ts
var pools114 = [];

// evm/constants/stableSwap/9000.ts
var pools115 = [];

// evm/constants/stableSwap/246.ts
var pools116 = [];

// evm/constants/stableSwap/73799.ts
var pools117 = [];

// evm/constants/stableSwap/8453.ts
var pools118 = [];

// evm/constants/stableSwap/84531.ts
var pools119 = [];

// evm/constants/stableSwap/2222.ts
var pools120 = [];

// evm/constants/stableSwap/2221.ts
var pools121 = [];

// evm/constants/stableSwap/1024.ts
var pools122 = [];

// evm/constants/stableSwap/1023.ts
var pools123 = [];

// evm/constants/stableSwap/1131.ts
var pools124 = [];

// evm/constants/stableSwap/1132.ts
var pools125 = [];

// evm/constants/stableSwap/1039.ts
var pools126 = [];

// evm/constants/stableSwap/1038.ts
var pools127 = [];

// evm/constants/stableSwap/314.ts
var pools128 = [];

// evm/constants/stableSwap/314159.ts
var pools129 = [];

// evm/constants/stableSwap/14.ts
var pools130 = [];

// evm/constants/stableSwap/114.ts
var pools131 = [];

// evm/constants/stableSwap/841.ts
var pools132 = [];

// evm/constants/stableSwap/842.ts
var pools133 = [];

// evm/constants/stableSwap/324.ts
var pools134 = [];

// evm/constants/stableSwap/280.ts
var pools135 = [];

// evm/constants/stableSwap/59144.ts
var pools136 = [];

// evm/constants/stableSwap/59140.ts
var pools137 = [];

// evm/constants/stableSwap/204.ts
var pools138 = [];

// evm/constants/stableSwap/5611.ts
var pools139 = [];

// evm/constants/stableSwap/43288.ts
var pools140 = [];

// evm/constants/stableSwap/56288.ts
var pools141 = [];

// evm/constants/stableSwap/199.ts
var pools142 = [];

// evm/constants/stableSwap/1029.ts
var pools143 = [];

// evm/constants/stableSwap/256256.ts
var pools144 = [];

// evm/constants/stableSwap/512512.ts
var pools145 = [];

// evm/constants/stableSwap/1116.ts
var pools146 = [];

// evm/constants/stableSwap/1115.ts
var pools147 = [];

// evm/constants/stableSwap/1818.ts
var pools148 = [];

// evm/constants/stableSwap/1819.ts
var pools149 = [];

// evm/constants/stableSwap/44.ts
var pools150 = [];

// evm/constants/stableSwap/43.ts
var pools151 = [];

// evm/constants/stableSwap/15.ts
var pools152 = [];

// evm/constants/stableSwap/13.ts
var pools153 = [];

// evm/constants/stableSwap/60.ts
var pools154 = [];

// evm/constants/stableSwap/31337.ts
var pools155 = [];

// evm/constants/stableSwap/11235.ts
var pools156 = [];

// evm/constants/stableSwap/54211.ts
var pools157 = [];

// evm/constants/stableSwap/24.ts
var pools158 = [];

// evm/constants/stableSwap/242.ts
var pools159 = [];

// evm/constants/stableSwap/11.ts
var pools160 = [];

// evm/constants/stableSwap/12.ts
var pools161 = [];

// evm/constants/stableSwap/11297108109.ts
var pools162 = [];

// evm/constants/stableSwap/11297108099.ts
var pools163 = [];

// evm/constants/stableSwap/333999.ts
var pools164 = [];

// evm/constants/stableSwap/333888.ts
var pools165 = [];

// evm/constants/stableSwap/27.ts
var pools166 = [];

// evm/constants/stableSwap/10000.ts
var pools167 = [];

// evm/constants/stableSwap/10001.ts
var pools168 = [];

// evm/constants/stableSwap/19.ts
var pools169 = [];

// evm/constants/stableSwap/7.ts
var pools170 = [];

// evm/constants/stableSwap/8.ts
var pools171 = [];

// evm/constants/stableSwap/9.ts
var pools172 = [];

// evm/constants/stableSwap/100009.ts
var pools173 = [];

// evm/constants/stableSwap/100010.ts
var pools174 = [];

// evm/constants/stableSwap/50.ts
var pools175 = [];

// evm/constants/stableSwap/51.ts
var pools176 = [];

// evm/constants/stableSwap/534352.ts
var pools177 = [];

// evm/constants/stableSwap/534351.ts
var pools178 = [];

// evm/constants/stableSwap/1440002.ts
var pools179 = [];

// evm/constants/stableSwap/7000.ts
var pools180 = [];

// evm/constants/stableSwap/7001.ts
var pools181 = [];

// evm/constants/stableSwap/55.ts
var pools182 = [];

// evm/constants/stableSwap/pools.ts
var isStableSwapSupported = (chainId) => STABLE_SUPPORTED_CHAIN_IDS.includes(chainId);
var STABLE_SUPPORTED_CHAIN_IDS = [
  ChainId.FIRECHAIN,
  ChainId.RINIA,
  ChainId.FIRECHAIN_ZKEVM,
  ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER,
  ChainId.ETHEREUM,
  ChainId.GOERLI,
  ChainId.SEPOLIA,
  ChainId.HOLESKY,
  ChainId.BSC,
  ChainId.BSC_TESTNET,
  ChainId.POLYGON,
  ChainId.POLYGON_AMOY,
  ChainId.POLYGON_ZKEVM,
  ChainId.POLYGON_ZKEVM_TESTNET,
  ChainId.CRO,
  ChainId.CRO_TESTNET,
  ChainId.AVALANCHE,
  ChainId.AVALANCHE_FUJI,
  ChainId.FANTOM_OPERA,
  ChainId.FANTOM_TESTNET,
  ChainId.CELO,
  ChainId.CELO_ALFAJORES,
  ChainId.OPTIMISM,
  ChainId.OPTIMISM_GOERLI,
  ChainId.ARBITRUM_ONE,
  ChainId.ARBITRUM_GOERLI,
  ChainId.SHIBARIUM,
  ChainId.SHIBARIUM_TESTNET,
  ChainId.PULSECHAIN,
  ChainId.PULSECHAIN_TESTNET,
  ChainId.XEN,
  ChainId.XEN_DEVNET,
  ChainId.HARMONY,
  ChainId.HARMONY_TESTNET,
  ChainId.COINEX,
  ChainId.COINEX_TESTNET,
  ChainId.DOGECHAIN,
  ChainId.DOGECHAIN_TESTNET,
  ChainId.ENGRAM_TESTNET,
  ChainId.ETHEREUM_CLASSIC,
  ChainId.ETHEREUM_CLASSIC_TESTNET,
  ChainId.FUSION,
  ChainId.FUSION_TESTNET,
  ChainId.HECO,
  ChainId.HECO_TESTNET,
  ChainId.KCC,
  ChainId.KCC_TESTNET,
  ChainId.KLAYTN,
  ChainId.KLAYTN_BAOBAB,
  ChainId.OKXCHAIN,
  ChainId.OKXCHAIN_TESTNET,
  ChainId.THETHA,
  ChainId.THETHA_TESTNET,
  ChainId.ULTRON,
  ChainId.ULTRON_TESTNET,
  ChainId.MOONBEAM,
  ChainId.MOONRIVER,
  ChainId.MOONBASE_ALPHA,
  ChainId.AURORA,
  ChainId.AURORA_TESTNET,
  ChainId.BOBA,
  ChainId.BOBA_GOERLI,
  ChainId.GNOSIS,
  ChainId.GNOSIS_CHIADO,
  ChainId.METIS,
  ChainId.METIS_GOERLI,
  ChainId.TELOS,
  ChainId.TELOS_TESTNET,
  ChainId.SYSCOIN,
  ChainId.SYSCOIN_TANENBAUM,
  ChainId.IOTEX,
  ChainId.IOTEX_TESTNET,
  ChainId.SHIDEN,
  ChainId.ASTAR,
  ChainId.SHIBUNYA,
  ChainId.FUSE,
  ChainId.FUSE_SPARKNET,
  ChainId.VELAS,
  ChainId.VELAS_TESTNET,
  ChainId.REI,
  ChainId.REI_TESTNET,
  ChainId.KEKCHAIN,
  ChainId.KEKCHAIN_TESTNET,
  ChainId.TOMOCHAIN,
  ChainId.TOMOCHAIN_TESTNET,
  ChainId.THUNDERCORE,
  ChainId.THUNDERCORE_TESTNET,
  ChainId.WANCHAIN,
  ChainId.WANCHAIN_TESTNET,
  ChainId.RSK,
  ChainId.RSK_TESTNET,
  ChainId.ELASTOS,
  ChainId.ELASTOS_TESTNET,
  ChainId.CONFLUX,
  ChainId.CONFLUX_TESTNET,
  ChainId.BRISECHAIN,
  ChainId.BRISECHAIN_TESTNET,
  ChainId.MUUCHAIN,
  ChainId.MUUCHAIN_TESTNET,
  ChainId.CANTO,
  ChainId.CANTO_TESTNET,
  ChainId.OASIS_EMERALD,
  ChainId.OASIS_TESTNET,
  ChainId.VISION,
  ChainId.VISION_TESTNET,
  ChainId.STEP,
  ChainId.STEP_TESTNET,
  ChainId.METER,
  ChainId.METER_TESTNET,
  ChainId.GODWOKEN,
  ChainId.GODWOKEN_TESTNET,
  ChainId.CALLISTO,
  ChainId.CALLISTO_TESTNET,
  ChainId.EVMOS,
  ChainId.EVMOS_TESTNET,
  ChainId.ENERGY_WEB_CHAIN,
  ChainId.ENERGY_VOLTA,
  ChainId.BASE,
  ChainId.BASE_GOERLI,
  ChainId.KAVA,
  ChainId.KAVA_TESTNET,
  ChainId.CLOVER,
  ChainId.CLOVER_TESTNET,
  ChainId.DEFICHAIN,
  ChainId.DEFICHAIN_TESTNET,
  ChainId.BRONOS,
  ChainId.BRONOS_TESTNET,
  ChainId.FILECOIN,
  ChainId.FILECOIN_CALIBRATION,
  ChainId.FLARE,
  ChainId.FLARE_TESTNET,
  ChainId.TARAXA,
  ChainId.TARAXA_TESTNET,
  ChainId.ZKSYNC,
  ChainId.ZKSYNC_TESTNET,
  ChainId.LINEA,
  ChainId.LINEA_TESTNET,
  ChainId.BTTCHAIN,
  ChainId.BTTCHAIN_TESTNET,
  ChainId.BOBA_AVAX,
  ChainId.BOBA_BNB,
  ChainId.CMP,
  ChainId.CMP_TESTNET,
  ChainId.CORE,
  ChainId.CORE_TESTNET,
  ChainId.CUBECHAIN,
  ChainId.CUBECHAIN_TESTNET,
  ChainId.DARWINIA_CRAB,
  ChainId.DARWINIA_PANGOLIN,
  ChainId.DIODE_PRETNET,
  ChainId.DIODE_TESTNET,
  ChainId.GOCHAIN,
  ChainId.GOCHAIN_TESTNET,
  ChainId.HAQQ,
  ChainId.HAQQ_TESTEDGE2,
  ChainId.KARDIACHAIN,
  ChainId.KARDIACHAIN_TESTNET,
  ChainId.METADIUM,
  ChainId.METADIUM_TESTNET,
  ChainId.OP_BNB,
  ChainId.OP_BNB_TESTNET,
  ChainId.PALM,
  ChainId.PALM_TESTNET,
  ChainId.POLIS,
  ChainId.POLIS_TESTNET,
  ChainId.SHIBACHAIN,
  ChainId.SMART_BCH,
  ChainId.SMART_BCH_TESTNET,
  ChainId.SONGBIRD_CANARY,
  ChainId.THAICHAIN,
  ChainId.UBIQ,
  ChainId.UBIQ_TESTNET,
  ChainId.VECHAIN,
  ChainId.VECHAIN_TESTNET,
  ChainId.XINFIN,
  ChainId.XINFIN_APOTHEM,
  ChainId.SCROLL,
  ChainId.SCROLL_SEPOLIA,
  ChainId.XRPL_DEVNET,
  ChainId.ZETACHAIN,
  ChainId.ZETACHAIN_ATHENS,
  ChainId.ZYX
];
var STABLE_POOL_MAP = {
  [ChainId.FIRECHAIN]: pools,
  [ChainId.RINIA]: pools2,
  [ChainId.FIRECHAIN_ZKEVM]: pools3,
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: pools4,
  [ChainId.ETHEREUM]: pools5,
  [ChainId.GOERLI]: pools6,
  [ChainId.SEPOLIA]: pools7,
  [ChainId.HOLESKY]: pools8,
  [ChainId.BSC]: pools9,
  [ChainId.BSC_TESTNET]: pools10,
  [ChainId.POLYGON]: pools11,
  [ChainId.POLYGON_AMOY]: pools12,
  [ChainId.POLYGON_ZKEVM]: pools13,
  [ChainId.POLYGON_ZKEVM_TESTNET]: pools14,
  [ChainId.CRO]: pools15,
  [ChainId.CRO_TESTNET]: pools16,
  [ChainId.AVALANCHE]: pools17,
  [ChainId.AVALANCHE_FUJI]: pools18,
  [ChainId.FANTOM_OPERA]: pools19,
  [ChainId.FANTOM_TESTNET]: pools20,
  [ChainId.CELO]: pools21,
  [ChainId.CELO_ALFAJORES]: pools22,
  [ChainId.OPTIMISM]: pools23,
  [ChainId.OPTIMISM_GOERLI]: pools24,
  [ChainId.ARBITRUM_ONE]: pools25,
  [ChainId.ARBITRUM_GOERLI]: pools26,
  [ChainId.SHIBARIUM]: pools27,
  [ChainId.SHIBARIUM_TESTNET]: pools28,
  [ChainId.PULSECHAIN]: pools29,
  [ChainId.PULSECHAIN_TESTNET]: pools30,
  [ChainId.XEN]: pools31,
  [ChainId.XEN_DEVNET]: pools32,
  [ChainId.HARMONY]: pools33,
  [ChainId.HARMONY_TESTNET]: pools34,
  [ChainId.COINEX]: pools35,
  [ChainId.COINEX_TESTNET]: pools36,
  [ChainId.DOGECHAIN]: pools37,
  [ChainId.DOGECHAIN_TESTNET]: pools38,
  [ChainId.ENGRAM_TESTNET]: pools39,
  [ChainId.ETHEREUM_CLASSIC]: pools40,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: pools41,
  [ChainId.FUSION]: pools42,
  [ChainId.FUSION_TESTNET]: pools43,
  [ChainId.HECO]: pools44,
  [ChainId.HECO_TESTNET]: pools45,
  [ChainId.KCC]: pools46,
  [ChainId.KCC_TESTNET]: pools47,
  [ChainId.KLAYTN]: pools48,
  [ChainId.KLAYTN_BAOBAB]: pools49,
  [ChainId.OKXCHAIN]: pools50,
  [ChainId.OKXCHAIN_TESTNET]: pools51,
  [ChainId.THETHA]: pools52,
  [ChainId.THETHA_TESTNET]: pools53,
  [ChainId.ULTRON]: pools54,
  [ChainId.ULTRON_TESTNET]: pools55,
  [ChainId.MOONBEAM]: pools56,
  [ChainId.MOONRIVER]: pools57,
  [ChainId.MOONBASE_ALPHA]: pools58,
  [ChainId.AURORA]: pools59,
  [ChainId.AURORA_TESTNET]: pools60,
  [ChainId.BOBA]: pools61,
  [ChainId.BOBA_GOERLI]: pools62,
  [ChainId.GNOSIS]: pools63,
  [ChainId.GNOSIS_CHIADO]: pools64,
  [ChainId.METIS]: pools65,
  [ChainId.METIS_GOERLI]: pools66,
  [ChainId.TELOS]: pools67,
  [ChainId.TELOS_TESTNET]: pools68,
  [ChainId.SYSCOIN]: pools69,
  [ChainId.SYSCOIN_TANENBAUM]: pools70,
  [ChainId.IOTEX]: pools71,
  [ChainId.IOTEX_TESTNET]: pools72,
  [ChainId.SHIDEN]: pools73,
  [ChainId.ASTAR]: pools74,
  [ChainId.SHIBUNYA]: pools75,
  [ChainId.FUSE]: pools76,
  [ChainId.FUSE_SPARKNET]: pools77,
  [ChainId.VELAS]: pools78,
  [ChainId.VELAS_TESTNET]: pools79,
  [ChainId.REI]: pools80,
  [ChainId.REI_TESTNET]: pools81,
  [ChainId.KEKCHAIN]: pools82,
  [ChainId.KEKCHAIN_TESTNET]: pools83,
  [ChainId.TOMOCHAIN]: pools84,
  [ChainId.TOMOCHAIN_TESTNET]: pools85,
  [ChainId.THUNDERCORE]: pools86,
  [ChainId.THUNDERCORE_TESTNET]: pools87,
  [ChainId.WANCHAIN]: pools88,
  [ChainId.WANCHAIN_TESTNET]: pools89,
  [ChainId.RSK]: pools90,
  [ChainId.RSK_TESTNET]: pools91,
  [ChainId.ELASTOS]: pools92,
  [ChainId.ELASTOS_TESTNET]: pools93,
  [ChainId.CONFLUX]: pools94,
  [ChainId.CONFLUX_TESTNET]: pools95,
  [ChainId.BRISECHAIN]: pools96,
  [ChainId.BRISECHAIN_TESTNET]: pools97,
  [ChainId.MUUCHAIN]: pools98,
  [ChainId.MUUCHAIN_TESTNET]: pools99,
  [ChainId.CANTO]: pools100,
  [ChainId.CANTO_TESTNET]: pools101,
  [ChainId.OASIS_EMERALD]: pools102,
  [ChainId.OASIS_TESTNET]: pools103,
  [ChainId.VISION]: pools104,
  [ChainId.VISION_TESTNET]: pools105,
  [ChainId.STEP]: pools106,
  [ChainId.STEP_TESTNET]: pools107,
  [ChainId.METER]: pools108,
  [ChainId.METER_TESTNET]: pools109,
  [ChainId.GODWOKEN]: pools110,
  [ChainId.GODWOKEN_TESTNET]: pools111,
  [ChainId.CALLISTO]: pools112,
  [ChainId.CALLISTO_TESTNET]: pools113,
  [ChainId.EVMOS]: pools114,
  [ChainId.EVMOS_TESTNET]: pools115,
  [ChainId.ENERGY_WEB_CHAIN]: pools116,
  [ChainId.ENERGY_VOLTA]: pools117,
  [ChainId.BASE]: pools118,
  [ChainId.BASE_GOERLI]: pools119,
  [ChainId.KAVA]: pools120,
  [ChainId.KAVA_TESTNET]: pools121,
  [ChainId.CLOVER]: pools122,
  [ChainId.CLOVER_TESTNET]: pools123,
  [ChainId.DEFICHAIN]: pools124,
  [ChainId.DEFICHAIN_TESTNET]: pools125,
  [ChainId.BRONOS]: pools126,
  [ChainId.BRONOS_TESTNET]: pools127,
  [ChainId.FILECOIN]: pools128,
  [ChainId.FILECOIN_CALIBRATION]: pools129,
  [ChainId.FLARE]: pools130,
  [ChainId.FLARE_TESTNET]: pools131,
  [ChainId.TARAXA]: pools132,
  [ChainId.TARAXA_TESTNET]: pools133,
  [ChainId.ZKSYNC]: pools134,
  [ChainId.ZKSYNC_TESTNET]: pools135,
  [ChainId.LINEA]: pools136,
  [ChainId.LINEA_TESTNET]: pools137,
  [ChainId.BTTCHAIN]: pools142,
  [ChainId.BTTCHAIN_TESTNET]: pools143,
  [ChainId.BOBA_AVAX]: pools140,
  [ChainId.BOBA_BNB]: pools141,
  [ChainId.CMP]: pools144,
  [ChainId.CMP_TESTNET]: pools145,
  [ChainId.CORE]: pools146,
  [ChainId.CORE_TESTNET]: pools147,
  [ChainId.CUBECHAIN]: pools148,
  [ChainId.CUBECHAIN_TESTNET]: pools149,
  [ChainId.DARWINIA_CRAB]: pools150,
  [ChainId.DARWINIA_PANGOLIN]: pools151,
  [ChainId.DIODE_PRETNET]: pools152,
  [ChainId.DIODE_TESTNET]: pools153,
  [ChainId.GOCHAIN]: pools154,
  [ChainId.GOCHAIN_TESTNET]: pools155,
  [ChainId.HAQQ]: pools156,
  [ChainId.HAQQ_TESTEDGE2]: pools157,
  [ChainId.KARDIACHAIN]: pools158,
  [ChainId.KARDIACHAIN_TESTNET]: pools159,
  [ChainId.METADIUM]: pools160,
  [ChainId.METADIUM_TESTNET]: pools161,
  [ChainId.OP_BNB]: pools138,
  [ChainId.OP_BNB_TESTNET]: pools139,
  [ChainId.PALM]: pools162,
  [ChainId.PALM_TESTNET]: pools163,
  [ChainId.POLIS]: pools164,
  [ChainId.POLIS_TESTNET]: pools165,
  [ChainId.SHIBACHAIN]: pools166,
  [ChainId.SMART_BCH]: pools167,
  [ChainId.SMART_BCH_TESTNET]: pools168,
  [ChainId.SONGBIRD_CANARY]: pools169,
  [ChainId.THAICHAIN]: pools170,
  [ChainId.UBIQ]: pools171,
  [ChainId.UBIQ_TESTNET]: pools172,
  [ChainId.VECHAIN]: pools173,
  [ChainId.VECHAIN_TESTNET]: pools174,
  [ChainId.XINFIN]: pools175,
  [ChainId.XINFIN_APOTHEM]: pools176,
  [ChainId.SCROLL]: pools177,
  [ChainId.SCROLL_SEPOLIA]: pools178,
  [ChainId.XRPL_DEVNET]: pools179,
  [ChainId.ZETACHAIN]: pools180,
  [ChainId.ZETACHAIN_ATHENS]: pools181,
  [ChainId.ZYX]: pools182
};

// evm/constants/stableSwap/index.ts
function getStableSwapPools(chainId) {
  if (!isStableSwapSupported(chainId)) {
    return [];
  }
  return STABLE_POOL_MAP[chainId] || [];
}
function wrappedCurrency(currency, chainId) {
  return currency?.isNative ? WNATIVE[chainId] : currency?.isToken ? currency : void 0;
}
function wrappedCurrencyAmount(currencyAmount, chainId) {
  const token = currencyAmount && chainId ? wrappedCurrency(currencyAmount.currency, chainId) : void 0;
  return token && currencyAmount ? CurrencyAmount.fromRawAmount(token, currencyAmount.quotient) : void 0;
}

// evm/abis/IDonaswapPair.ts
var donaswapPairABI = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Burn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint112",
        name: "reserve0",
        type: "uint112"
      },
      {
        indexed: false,
        internalType: "uint112",
        name: "reserve1",
        type: "uint112"
      }
    ],
    name: "Sync",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MINIMUM_LIQUIDITY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getReserves",
    outputs: [
      {
        internalType: "uint112",
        name: "reserve0",
        type: "uint112"
      },
      {
        internalType: "uint112",
        name: "reserve1",
        type: "uint112"
      },
      {
        internalType: "uint32",
        name: "blockTimestampLast",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "kLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "price0CumulativeLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "price1CumulativeLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "skim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "sync",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token0",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "token1",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// evm/abis/StableSwapPair.ts
var stableSwapPairABI = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "token_amounts",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "fees",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "invariant",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_supply",
        type: "uint256"
      }
    ],
    name: "AddLiquidity",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "admin_fee",
        type: "uint256"
      }
    ],
    name: "CommitNewFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "DonateAdminFees",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "Kill",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "admin_fee",
        type: "uint256"
      }
    ],
    name: "NewFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "old_A",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "new_A",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "initial_time",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "future_time",
        type: "uint256"
      }
    ],
    name: "RampA",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "token_amounts",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "fees",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_supply",
        type: "uint256"
      }
    ],
    name: "RemoveLiquidity",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "token_amounts",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "fees",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "invariant",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_supply",
        type: "uint256"
      }
    ],
    name: "RemoveLiquidityImbalance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "coin_amount",
        type: "uint256"
      }
    ],
    name: "RemoveLiquidityOne",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "RevertParameters",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "A",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "t",
        type: "uint256"
      }
    ],
    name: "StopRampA",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "buyer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sold_id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokens_sold",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bought_id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokens_bought",
        type: "uint256"
      }
    ],
    name: "TokenExchange",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "Unkill",
    type: "event"
  },
  {
    inputs: [],
    name: "A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ADMIN_ACTIONS_DELAY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "FEE_DENOMINATOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "KILL_DEADLINE_DT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_ADMIN_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_A_CHANGE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_DECIMAL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MIN_RAMP_TIME",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "N_COINS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "PRECISION_MUL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "RATES",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "STABLESWAP_FACTORY",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      },
      {
        internalType: "uint256",
        name: "min_mint_amount",
        type: "uint256"
      }
    ],
    name: "add_liquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "admin_actions_deadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      }
    ],
    name: "admin_balances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "admin_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "apply_new_fee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "balances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      },
      {
        internalType: "bool",
        name: "deposit",
        type: "bool"
      }
    ],
    name: "calc_token_amount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_token_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      }
    ],
    name: "calc_withdraw_one_coin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "coins",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "new_fee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "new_admin_fee",
        type: "uint256"
      }
    ],
    name: "commit_new_fee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "donate_admin_fees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "j",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "min_dy",
        type: "uint256"
      }
    ],
    name: "exchange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_A_time",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_admin_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "j",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256"
      }
    ],
    name: "get_dy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "j",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256"
      }
    ],
    name: "get_dy_underlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "get_virtual_price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initial_A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initial_A_time",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[2]",
        name: "_coins",
        type: "address[2]"
      },
      {
        internalType: "uint256",
        name: "_A",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_fee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_admin_fee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "is_killed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "kill_deadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "kill_me",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_future_A",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_future_time",
        type: "uint256"
      }
    ],
    name: "ramp_A",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "uint256[2]",
        name: "min_amounts",
        type: "uint256[2]"
      }
    ],
    name: "remove_liquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      },
      {
        internalType: "uint256",
        name: "max_burn_amount",
        type: "uint256"
      }
    ],
    name: "remove_liquidity_imbalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_token_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "min_amount",
        type: "uint256"
      }
    ],
    name: "remove_liquidity_one_coin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "revert_new_parameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "stop_rampget_A",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract DonaswapStableSwapLP",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unkill_me",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdraw_admin_fees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

export { ADDITIONAL_BASES, ADDRESS_THIS, BASES_TO_CHECK_TRADES_AGAINST, BASE_SWAP_COST_STABLE_SWAP, BASE_SWAP_COST_V2, BASE_SWAP_COST_V3, BATCH_MULTICALL_CONFIGS, BETTER_TRADE_LESS_HOPS_THRESHOLD, BIG_INT_TEN, BIPS_BASE, CHAIN_ID_TO_CHAIN_NAME, COST_PER_EXTRA_HOP_STABLE_SWAP, COST_PER_EXTRA_HOP_V2, COST_PER_HOP_V3, COST_PER_INIT_TICK, COST_PER_UNINIT_TICK, CUSTOM_BASES, MIN_BNB, MIXED_ROUTE_QUOTER_ADDRESSES, MSG_SENDER, SMART_ROUTER_ADDRESSES, STABLE_SUPPORTED_CHAIN_IDS, STABLE_SWAP_INFO_ADDRESS, V2_FEE_PATH_PLACEHOLDER, V2_ROUTER, V2_ROUTER_ADDRESS, V3_QUOTER_ADDRESSES, __export, donaswapPairABI, getStableSwapPools, isStableSwapSupported, stableSwapPairABI, usdGasTokensByChain, wrappedCurrency, wrappedCurrencyAmount };
